import React from "react";
import axios from "axios";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import "../just.css";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
//import { Table } from "reactstrap";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import EditorConvertToHTML from "./editor";
import DayPicker, { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";
import { encode } from "base-64";
import ReactTooltip from "react-tooltip";

import {
  Grid,
  Segment,
  Accordion,
  Pagination,
  Divider,
  Menu,
  Label,
  Header,
  Modal,
  Form,
  Step,
  Button,
  Icon,
  Input,
  Message,
  List,
  Checkbox,
} from "semantic-ui-react";
import DateTime from "react-datetime";
import Select from "react-select";

import PhoneInput from "react-phone-input-2";

import "react-phone-input-2";
import { thresholdScott } from "d3";
import { identity } from "lodash";
import { SMALL } from "material-ui/utils/withWidth";
import { API_BASE_URL } from "../utils/endpoints";

const commaNumber = require("comma-number");

var balance_type = [];

////////////////////////// from add bulk sms ////////////////////
var back = "";
var mobile = [];
var groupOptions = [];
var value_variables;
var value_variables_one;
var categoryOptions = [];
var categoryGroupOptions = [];
var array_data = [];
var category_ids = [];
var template = [];
var count = 1;
var data = new FormData();

const customStyles = {
  content: {
    left: "13%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
  },
};
const customStylesstop = {
  content: {
    width: "40%",
    marginRight: "30%",
    marginLeft: "30%",
    height: "231px",
    marginTop: "6%",
    background: " #fcfcfc !important",
    overflow: "auto",
  },
};
var ENGLISH =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789()+_*&^%$#@! {}[]|?><:"';

var countryOptions = [];
var yesterday = DateTime.moment().subtract(1, "day");
var valid = function(current) {
  return current.isAfter(yesterday);
};

const StepOneModal = {
  height: "auto",

  marginLeft: "30%",
  marginTop: 50,
};

const StepOneModala = {
  height: "auto",

  marginLeft: "15%",
  marginTop: 50,
};

const filter = {
  marginTop: 150,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
  width: 500,
};
const filtera = {
  marginTop: 150,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
  width: 500,
};

const modStop = {
  marginTop: 200,
  marginLeft: "30%",
  height: "auto",
  width: 700,
  textAlign: "left",
};

const modStopa = {
  marginTop: 200,
  marginLeft: "15%",
  height: "auto",
  width: 700,
  textAlign: "left",
};

const modDetails = {
  marginTop: 60,
  marginLeft: "25%",
  height: "auto",
  width: 1000,
  textAlign: "left",
};

const modDetailsa = {
  marginTop: 60,
  marginLeft: "15%",
  height: "auto",
  width: 1000,
  textAlign: "left",
};

class ReportBulk extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      selectedDays: [],
      countryOptions: [],
      view: [],
      TimesPerDay: [],
      perDay: "",
      modalIsOpen: false,
      modalOpenConfirm: false,
      show: false,
      collapsed: false,
      collapseID: "",
      data: [],
      Details: [],
      disabledButton: false,
      disabled: false,
      displayViewBox: false,
      ViewBoxDetails: false,

      bulktotalpage: 1,
      bulkactivePage: 1,

      searchbulktotalpage: 1,
      searchbulkactivePage: 1,

      contacttotalpage: 1,
      contactactivePage: 1,

      searchcontacttotalpage: 1,
      searchcontactactivePage: 1,

      totalpage: 1,
      activePage: 1,

      detailstotalpage: 1,
      detailActivePage: 1,

      searchdetailstotalpage: 1,
      searchdetailActivePage: 1,

      activePage_modal: 1,
      activePage_modal2: 1,
      idRecord: "",
      personssearch: [],
      searchword: "",
      date_format: [],
      modalIsOpenStop: false,
      id_stop: "",
      isLoading: true,
      isArabic: false,
      isOperator: true,
      bulk_balance: "",
      viewData: "",
      searchWord: "",
      viewAdd: true,
      modalOpenStopJop: false,
      modalOpenViewDetails: false,

      fromDate: "",
      toDate: "",
      modalOpenFilterDetails: false,
      filterTotalpage: 1,
      modalOpenBulkEdit: false,
      ////////////////////// form add bulk ////////////////////

      title: "",
      products: [
        { label: i18n.t("Number.label"), value: "single_numbers" },
        { label: i18n.t("File.label"), value: "file" },
        { label: i18n.t("Contact_List.label"), value: "single_numbers" },
        { label: i18n.t("Dynamic_File.label"), value: "dynamic_file" },
        { label: i18n.t("Group.label"), value: "group" },
        { label: i18n.t("Category.label"), value: "group" },
      ],
      typeofMSg: "",
      nameoftype: "",
      typeofvariable: "",
      nameofvariable: "",
      uploadfile: [],
      contactselect: [],
      senderidoption: [],
      senderid: [],
      length_category: 0,
      time: [
        { label: i18n.t("Send_Now.label"), value: 1 },
        { label: i18n.t("Schedule_time.label"), value: 2 },
      ],
      timeselect: [{ label: i18n.t("Send_Now.label"), value: 1 }],
      timeofsend: "",
      dateofsend: "",
      content: "",
      senderidselect: "",
      callbackDataValid: [{}],
      callbackDataInValid: [],
      modalIsOpen: false,
      modalIsOpenContact: false,
      modalOpenSellectContact: false,
      show: false,
      collapsed: false,
      collapseID: "",
      confirm: "",
      resultall: "",
      resultallinvalid: "",
      totalduplicate: 0,
      persons: [],
      contacttotalpage: 1,
      contactactivePage: 1,
      personssearch: [],
      totalmsg: "",
      contactArray: [],
      options_sender: [],
      groups_id: [],
      add_numbers: [],
      remove_numbers: [],
      groups: [],
      options_senders: [],
      items: [],
      focused: false,
      input: "",
      items2: [],
      input2: "",
      variables: [
        { label: "first_name", value: "first_name" },
        { label: "second_name", value: "second_name" },
        { label: "family_name", value: "family_name" },
        { label: "company", value: "company" },
        { label: "country", value: "country" },
        { label: "governerate", value: "governerate" },
        { label: "district", value: "district" },
        { label: "area", value: "area" },
        { label: "mobile_number", value: "mobile_number" },
        { label: "createdTime", value: "createdTime" },
        { label: "custom_filter1", value: "custom_filter1" },
        { label: "custom_filter2", value: "custom_filter2" },
        { label: "custom_filter3", value: "custom_filter3" },
        { label: "custom_filter4", value: "custom_filter4" },
        { label: "custom_filter5", value: "custom_filter5" },
        { label: "custom_filter6", value: "custom_filter6" },
      ],
      lenght_msg: "",
      date: new Date(),
      recurring: new Date(),
      send_now: true,
      options_sender_category: [],
      isArabic: false,
      balance_reserved: {},
      modalIsOpenScheule: false,
      file: null,
      inputKey: Date.now(),
      numberOfMessages: 0,
      activeIndex: 0,
      confirm_id: "",
      exportFlag: false,
    };

    /////////////////////////// from add bulk ///////////////

    this.openModalSchedule = this.openModalSchedule.bind(this);
    this.afterOpenModalSchedule = this.afterOpenModalSchedule.bind(this);
    this.closeModalSchedule = this.closeModalSchedule.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputKeyDown = this.handleInputKeyDown.bind(this);
    this.handleRemoveItem = this.handleRemoveItem.bind(this);
    this.handleInputChange2 = this.handleInputChange2.bind(this);
    this.handleInputKeyDown2 = this.handleInputKeyDown2.bind(this);
    this.handleRemoveItem2 = this.handleRemoveItem2.bind(this);
    this.handleDayClick = this.handleDayClick.bind(this);
  }

  onChangedatetimerecurring = (date) => {
    date = new Date(date);
    this.setState({ recurring: date });
  };

  addItem() {
    var ul = document.getElementById("dynamic-list");
    // var candidate = document.getElementById("candidate");
    var li = document.createElement("li");
    li.setAttribute("id", this.state.recurring);
    li.appendChild(document.createTextNode(this.state.recurring));
    ul.appendChild(li);
  }

  removeItem(index) {
    var day = this.state.recurring;
    var month = day.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    var hour = day.getHours();
    if (hour < 10) {
      hour = "0" + hour;
    }
    var date = day.getDate();
    if (date < 10) {
      date = "0" + date;
    }
    var minutes = day.getMinutes();
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    var dformat =
      [day.getFullYear(), month, date].join("-") +
      "T" +
      [hour, minutes, day.getSeconds() + "0"].join(":") +
      "Z";

    const selectedIndex = this.state.selectedDays.indexOf(dformat);
    this.state.selectedDays.splice(index, 1);
    console.log(index);
    console.log(this.state.selectedDays);
    this.setState({ view: this.state.selectedDays });
  }

  handleDayClick() {
    var day = this.state.recurring;
    var month = day.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    var hour = day.getHours();
    if (hour < 10) {
      hour = "0" + hour;
    }
    var date = day.getDate();
    if (date < 10) {
      date = "0" + date;
    }
    var minutes = day.getMinutes();
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    var dformat =
      [day.getFullYear(), month, date].join("-") +
      "T" +
      [hour, minutes, day.getSeconds() + "0"].join(":") +
      "Z";

    if (this.state.selectedDays.includes(dformat)) {
    } else {
      this.state.selectedDays.push(dformat);
      // var ul = document.getElementById("dynamic-list");
      // // var candidate = document.getElementById("candidate");

      // var li = document.createElement("li");

      //  li.setAttribute('id',dformat);

      //  li.appendChild(document.createTextNode(dformat));
      //  ul.appendChild(li);
    }

    console.log(this.state.selectedDays);
    var array = this.state.selectedDays;
    this.setState({ view: array });
    document.querySelector(".viewTable").style = "display:block";
  }

  handleOpenBulkEdit = () => this.setState({ modalOpenBulkEdit: true });
  handleCloseBulkEdit = () => this.setState({ modalOpenBulkEdit: false });

  handleOpenBulkSMSStepOne = () =>
    this.setState({ modalOpenBulkSMSStepOne: true });
  handleCloseBulkSMSStepOne = () =>
    this.setState({ modalOpenBulkSMSStepOne: false });

  handleOpenBulkSMSSteptTow = () =>
    this.setState({ modalOpenBulkSMSStepTow: true });
  handleCloseBulkSMSStepTow = () =>
    this.setState({ modalOpenBulkSMSStepTow: false });

  handleOpenSellectContact = () =>
    this.setState({ modalOpenSellectContact: true });
  handleCloseSellectContact = () =>
    this.setState({ modalOpenSellectContact: false });

  handleOpenConfirm = () => this.setState({ modalOpenConfirm: true });
  handleCloseConfirm = () => this.setState({ modalOpenConfirm: false });

  handleOpenStopJop = () => this.setState({ modalOpenStopJop: true });
  handleCloseStopJop = () => this.setState({ modalOpenStopJop: false });

  handleOpenViewDetails = () => this.setState({ modalOpenViewDetails: true });
  handleCloseViewDetails = () => this.setState({ modalOpenViewDetails: false });

  handleOpenFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: true });
  handleCloseFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: false });
  /******************************** Fast Track 11/7/2023 *************************************/
  onChangeFromDate = (event) => {
    const date = new Date(event.target.value);

    const datevalue = date.toLocaleDateString();
    console.log(datevalue);
    var array = datevalue.split("/");
    var day = array[1];
    var year = array[2];

    const month = date.toLocaleString("default", { month: "short" });
    console.log(month);
    const timevalue = date.toLocaleTimeString();
    var timearray = timevalue.split(" ");
    var time = timearray[0];

    var timees = timevalue.split(":");
    var time_1 = timees[0];

    if (timearray[1] == "PM") {
      time_1 = Number(time_1) + 12;
    } else if (timearray[1] == "AM") {
      if (time_1 < 10) {
        time_1 = 0 + time_1;
      }
    }

    //const fromDate = day + "-" + month + "-" + year + " " + time_1+":"+timees[1]+":"+timees[2]; 23:59:59
    const fromDate =
      day +
      "-" +
      month +
      "-" +
      year +
      " " +
      "00" +
      ":" +
      "00" +
      ":" +
      "00" +
      " " +
      "AM";

    this.setState({ fromDate: fromDate });
    console.log(fromDate);
  };

  /******************************** Fast Track 11/7/2023 *************************************/
  onChangeToDate = (event) => {
    const date = new Date(event.target.value);

    const datevalue = date.toLocaleDateString();

    var array = datevalue.split("/");
    var day = array[1];
    var year = array[2];
    const month = date.toLocaleString("default", { month: "short" });
    const timevalue = date.toLocaleTimeString();
    console.log(timevalue, "time");
    var timearray = timevalue.split(" ");
    var time = timearray[0];
    console.log(timearray[1]);

    var timees = timevalue.split(":");
    var time_1 = timees[0];

    if (timearray[1] == "PM") {
      time_1 = Number(time_1) + 12;
    } else if (timearray[1] == "AM") {
      if (time_1 < 10) {
        time_1 = 0 + time_1;
      }
    }

    //  const toDate = day + "-" + month + "-" + year + " " + time_1+":"+timees[1]+":"+timees[2];
    const toDate =
      day +
      "-" +
      month +
      "-" +
      year +
      " " +
      "23" +
      ":" +
      "23" +
      ":" +
      "59" +
      " " +
      "AM";

    console.log(toDate, "        toDate");
    this.setState({ toDate: toDate });
  };

  filterData() {
    this.setState({ modalOpenFilterDetails: false });
    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage - 1;
    var data = {
      searchQuery: "",
      page: 0,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      service_type: "bulk_sms",
    };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.count / 20);

      console.log(total);
      this.setState({ bulktotalpage: total });

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }

      if (res.data.result.jobs != undefined) {
        const data = res.data.result.jobs;
        this.setState({ data: data });
        this.setState({ isLoading: false });
        document.querySelector(".searchbulkpagination").style = "display:none";
        document.querySelector(".bulkpagination").style = "display:none";
        document.querySelector(".filterpagination").style = "display:block";
      }
      var i, j;

      var array = [];

      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });
  }

  handlePaginationFilterChange = (e, { activePage }) => {
    this.setState({ activePage });
    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage - 1;
    var data = {
      searchQuery: "",
      page: page_num,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      service_type: "bulk_sms",
    };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.count / 20);
      this.setState({ filterTotalpage: total });
      let result = res.data.result.result;

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }

      if (res.data.result.jobs != undefined) {
        const data = res.data.result.jobs;
        this.setState({ data: data });
        this.setState({ isLoading: false });
      }
      var i, j;

      var array = [];

      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });
  };

  componentWillMount() {
    this.findAllContact();
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      this.setState({ isOperator: false });
    }
    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage - 1;
    var data = { searchQuery: "", page: page_num, service_type: "bulk_sms" };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;
      document.querySelector(".searchbulkpagination").style = "display:none";
      document.querySelector(".bulkpagination").style = "display:block";
      document.querySelector(".filterpagination").style = "display:none";

      var total = Math.ceil(res.data.result.count / 20);

      console.log(total);
      this.setState({ bulktotalpage: total });
      let result = res.data.result.result;

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }

      if (res.data.result.jobs != undefined) {
        const data = res.data.result.jobs;
        if (res.data.result.count === 0) {
          this.setState({ exportFlag: false });
        } else {
          this.setState({ exportFlag: true });
        }
        this.setState({ data: data });
        this.setState({ isLoading: false });
      }
      var i, j;

      var array = [];

      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });

    var token = reactLocalStorage.get("accessToken");
    var user_id = this.state.user_id_login;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      } else {
        const data = res.data.result.balances;
        var array = [];
        if (data != undefined) {
          Object.keys(data).map(function(key) {
            array.push({
              label: key.replace(/_/g, " "),
              value: key,
            });
            balance_type = array;
          });
        }
      }
      this.setState({ code: "" });
    });
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      } else {
        const data = res.data.result.balances;
        var i;
        if (data) {
          var used;
          var reserved;
          var balance;
          var newbalance;
          var promo;
          var date = new Date();
          var day = date.getDate();
          if (day <= 9) {
            day = "0" + day;
          }
          var month = date.getMonth() + 1;
          if (month <= 9) {
            month = "0" + month;
          }
          var year = date.getFullYear();
          date = year + "-" + month + "-" + day;

          if (data.bulk_sms) {
            var expiry = data.bulk_sms.expiry;
            if (expiry < date) {
              this.setState({ isOperator: false });
            }
            used = data.bulk_sms.used;
            reserved = data.bulk_sms.reserved;
            balance = data.bulk_sms.balance;
            promo = data.bulk_sms_promotion;
            if (promo) {
              this.setState({ isPromotion: true });
            }
            if (used != undefined && reserved != undefined) {
              newbalance = balance - used - reserved;
            } else if (used === undefined && reserved === undefined) {
              newbalance = data.bulk_sms.balance;
            } else if (reserved != undefined) {
              newbalance = data.bulk_sms.balance - data.bulk_sms.reserved;
            } else if (used != undefined) {
              newbalance = data.bulk_sms.balance - data.bulk_sms.used;
            }
            if (newbalance < 0) {
              document.querySelector(".icon1 ").style = "display:none;";
            }
            this.setState({ bulk_balance: newbalance });

            this.setState({ bulk_expiry: data.bulk_sms.expiry });
          }
          if (data.profiled) {
            used = data.profiled.used;
            reserved = data.profiled.reserved;
            balance = data.profiled.balance;
            newbalance = balance - used - reserved;
            /*  promo=data.profiled.data.profiled+'_'+promotion;
                      if(promo){
                        this.setState({isPromotion:true})
                      }*/
            if (used === undefined && reserved === undefined) {
              newbalance = data.profiled.balance;
            }
            if (reserved != undefined) {
              newbalance = data.profiled.balance - data.profiled.reserved;
            }
            if (used != undefined) {
              newbalance = data.profiled.balance - data.profiled.used;
            }
            this.setState({ profiled_balance: newbalance });
            this.setState({ profiled_expiry: data.profiled.expiry });
          }
          if (data.lba) {
            used = data.lba.used;
            reserved = data.lba.reserved;
            balance = data.lba.balance;
            newbalance = balance - used - reserved;
            /* promo=data.lba.data.lba+'_'+promotion;
                      if(promo){
                        this.setState({isPromotion:true})
                      }*/
            if (used === undefined && reserved === undefined) {
              newbalance = data.lba.balance;
            }
            if (reserved != undefined) {
              newbalance = data.lba.balance - data.lba.reserved;
            }
            if (used != undefined) {
              newbalance = data.lba.balance - data.lba.used;
            }

            this.setState({ lba_balance: newbalance });
            this.setState({ lba_expiry: data.lba.expiry });
          }
          if (data.survey) {
            used = data.survey.used;
            reserved = data.survey.reserved;
            balance = data.survey.balance;
            newbalance = balance - used - reserved;
            /* promo=data.survey.data.survey+'_'+promotion;
                      if(promo){
                        this.setState({isPromotion:true})
                      }*/
            if (used === undefined && reserved === undefined) {
              newbalance = data.survey.balance;
            }
            if (reserved != undefined) {
              newbalance = data.survey.balance - data.survey.reserved;
            }
            if (used != undefined) {
              newbalance = data.survey.balance - data.survey.used;
            }
            this.setState({ survey_balance: newbalance });
            this.setState({ survey_expiry: data.survey.expiry });
          }
          if (data.international) {
            used = data.international.used;
            reserved = data.international.reserved;
            balance = data.international.balance;
            newbalance = balance - used - reserved;
            /*  promo=data.international.data.international+'_'+promotion;
                      if(promo){
                        this.setState({isPromotion:true})
                      }*/
            if (used === undefined && reserved === undefined) {
              newbalance = data.international.balance;
            }
            if (reserved != undefined) {
              newbalance =
                data.international.balance - data.international.reserved;
            }
            if (used != undefined) {
              newbalance = data.international.balance - data.international.used;
            }

            this.setState({ inter_balance: newbalance });
            this.setState({ inter_expiry: data.international.expiry });
          }
        } else {
          this.setState({ isOperator: false });
          this.setState({ bulk_balance: 0 });
        }
      }
    });
  }

  getDataPage = () => {
    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage - 1;
    var data = { searchQuery: "", page: page_num };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.count / 20);

      this.setState({ totalpage: total });
      let result = res.data.result.result;

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }

      if (res.data.result.jobs != undefined) {
        const data = res.data.result.jobs;
        this.setState({ data });
        this.setState({ isLoading: false });
        this.forceUpdate();
      }
      var i, j;

      var array = [];

      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });
  };

  stopJob = (event) => {
    this.setState({ id_stop: event.target.id });
    this.setState({ modalOpenStopJop: true });
  };

  confirmStop = () => {
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/stopJob/" +
        this.state.id_stop;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/jobs/stopJob/" +
        this.state.id_stop;
    }

    var data = {};
    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: res.data.result.message,
        animation: "bounce",
        time: 5000,
      });
      this.setState({ modalIsOpenStop: false });
      var token = reactLocalStorage.get("accessToken");
      var page_num = this.state.activePage - 1;
      var data = { searchQuery: "", page: page_num };
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/jobs/searchJobs";
      } else {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
      }
      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
        if (res.data.status === "success") {
          const data = res.data.result.jobs;
          if (data != undefined) {
            this.setState({ data });
            window.location = "ReportBulk";
          }
        }
      });
    });
  };

  viewdata = (event) => {
    this.setState({ idRecord: event.target.id });
    this.setState({ modalOpenViewDetails: true });
    //document.querySelector(".fixed_header").style = "z-index:-1";

    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage_modal - 1;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        event.target.id +
        "/page=" +
        page_num +
        "/getJobdetails";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        event.target.id +
        "/page=" +
        page_num +
        "/getJobdetails";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.messages_count / 20);

      this.setState({ detailstotalpage: total });

      let result = res.data.result.result;

      if (res.data.result.result != undefined) {
        const Details = res.data.result.result;
        this.setState({ Details: Details });
      }
    });
  };

  handlePaginationChangeSearchBasic = (e, { activePage }) => {
    this.setState({ activePage });

    //document.querySelector(".view_basic").style = "display:none";
    //document.querySelector(".view_search_basic").style = "display:block";
    var token = reactLocalStorage.get("accessToken");
    var page_num = activePage - 1;
    var data = {
      searchQuery: this.state.searchWord,
      page: page_num,
      service_type: "bulk_sms",
    };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;
      var total = Math.ceil(res.data.result.count / 20);

      this.setState({ searchbulktotalpage: total });

      let result = res.data.result.result;

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }

      if (res.data.result.jobs != undefined) {
        this.setState({ data: res.data.result.jobs });
        this.setState({ isLoading: false });
      }
      var i, j;

      var array = [];

      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });
  };

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });

    var token = reactLocalStorage.get("accessToken");
    var data1 = {
      searchQuery: "",
      page: activePage - 1,
      service_type: "bulk_sms",
    };
    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data1, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.count / 20);

      this.setState({ totalpage: total });
      let result = res.data.result.result;

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }

      if (res.data.result.jobs != undefined) {
        const data = res.data.result.jobs;
        this.setState({ data });
        this.setState({ isLoading: false });
      }
      var i, j;

      var array = [];

      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });
  };

  handlePaginationChangeactivePage_modal = (e, { activePage }) => {
    var x = this;
    x.setState({ activePage });
    console.log(
      "handlePaginationChangeactivePage_modal activePage",
      this.state.activePage
    );
    this.setState({ modalIsOpen: true });
    // document.querySelector(".fixed_header").style = "z-index:-1";
    var token = reactLocalStorage.get("accessToken");
    var page_num = activePage - 1;
    console.log("handlePaginationChangeactivePage_modal", page_num);

    
    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        this.state.idRecord +
        "/page=" +
        page_num +
        "/getJobdetails";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        this.state.idRecord +
        "/page=" +
        page_num +
        "/getJobdetails";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      var total = Math.ceil(res.data.result.messages_count / 20);

      this.setState({ totalpage: total });
      console.log("total page ", this.state.totalpage);
      let result = res.data.result.result;

      if (res.data.result.result != undefined) {
        const data = res.data.result.result;
        this.setState({ Details: data });

        this.forceUpdate();
      }
    });
  };

  handlePaginationChangeContact = (e, { activePage }) => {
    this.setState({ activePage });
    var token = reactLocalStorage.get("accessToken");
    reactLocalStorage.get("user_id_login");
    var contactspagenumber = 0;
    contactspagenumber = activePage - 1;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        contactspagenumber +
        "/findallcontacts";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        contactspagenumber +
        "/findallcontacts";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const persons = res.data.result.contacts;
      var totalContactspages = Math.ceil(res.data.result.total_contacts / 20);
      this.setState({ contacttotalpage: totalContactspages });
      if (res.data.result.contacts != undefined) {
        this.setState({ persons });
      }
    });
  };

  searchchange = (event) => {
    this.setState({ searchWord: event.target.value });
    if (event.target.value.length >= 2 || event.target.value == "") {
      document.querySelector(".detailspagination").style = "display:none";
      document.querySelector(".searchdetailspagination").style =
        "display:block";
      var token = reactLocalStorage.get("accessToken");
      var data = { searchQuey: event.target.value, page: 0 };

      var ip = API_BASE_URL;

      var s2 = "localhost:3000";

      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/jobs/user=" +
          reactLocalStorage.get("user_id_login") +
          "/job=" +
          this.state.idRecord +
          "/searchJobdetails";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/jobs/user=" +
          reactLocalStorage.get("user_id_login") +
          "/job=" +
          this.state.idRecord +
          "/searchJobdetails";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
        const data = res.data.result;

        var total = Math.ceil(res.data.result.messages_count / 20);

        this.setState({ searchdetailstotalpage: total });

        // this.setState({ totalpage: total });
        let result = res.data.result.result;

        if (res.data.result.result != undefined) {
          const persons = res.data.result.result;
          this.setState({ Details: persons });
        }
      });
    }
  };

  searchchangepage = (e, { activePage }) => {
    this.setState({ activePage });
    var token = reactLocalStorage.get("accessToken");
    console.log(this.state.searchWord);
    var data = { searchQuey: this.state.searchWord, page: activePage - 1 };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        this.state.idRecord +
        "/searchJobdetails";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        this.state.idRecord +
        "/searchJobdetails";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.messages_count / 20);

      this.setState({ searchdetailstotalpage: total });
      let result = res.data.result.result;

      if (res.data.result.result != undefined) {
        const persons = res.data.result.result;
        this.setState({ Details: persons });
      }
    });
  };
  test(value) {
    var d = new Date(value),
      dformat =
        [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
    return dformat;
  }

  searchchangemain = (event) => {
    this.setState({ searchWord: event.target.value });
    if (event.target.value.length >= 2) {
      document.querySelector(".bulkpagination").style = "display:none";
      document.querySelector(".searchbulkpagination").style = "display:block";
      var token = reactLocalStorage.get("accessToken");
      var page_num = 0;
      var data = {
        searchQuery: event.target.value,
        page: page_num,
        service_type: "bulk_sms",
      };

      var ip = API_BASE_URL;

      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/jobs/searchJobs";
      } else {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
        const data = res.data.result;
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ searchbulktotalpage: total });

        let result = res.data.result.result;

        if (res.data.result.ErrorDescription === "user is not authenticated") {
          window.location = "/app/";
        }

        if (res.data.result.jobs != undefined) {
          this.setState({ data: res.data.result.jobs });
          this.setState({ isLoading: false });
        }
        var i, j;

        var array = [];

        for (i = 0; i < data.length; i++) {
          var d = new Date(data[i].schedule_date),
            dformat =
              [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
              " " +
              [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
          array.push({ date: dformat });
        }
        this.setState({ date_format: array });
      });
    }
    if (event.target.value === "") {
      document.querySelector(".bulkpagination").style = "display:block";
      document.querySelector(".searchbulkpagination").style = "display:none";
      this.componentWillMount();
    }
  };

  export_details = (event) => {
    var x = this;
    x.setState({
      ViewBoxDetails: true,
    });
    var idRecord = this.state.idRecord;
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_job_" + idRecord;

    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" +
        collectionName;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" + collectionName;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .get(apiBaseUrl, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.status != "ready to download" ||
            response.data.status === "proccessing file" ||
            response.data.status === "Genrating File still in progress"
          ) {
            x.export_detailsInterval();
            x.setState({ viewData: response.data.status });
          } else if (response.data.status === "ready to download") {
            x.setState({ viewData: response.data.status });

            var collectionName = response.data.file_name;
            if (ip.includes(s2)) {
              window.location =
                API_BASE_URL + "/core/user/rest/Export/" +
                collectionName +
                "/download";
            } else {
              window.location =
                API_BASE_URL +
                "/core/user/rest/Export/" +
                collectionName +
                "/download";
            }
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  export_detailsInterval = (event) => {
    var x = this;
    var idRecord = this.state.idRecord;
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_job_" + idRecord;

    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" +
        collectionName;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" + collectionName;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    var callexport = setInterval(function() {
      axios
        .get(apiBaseUrl, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (
              response.data.status != "ready to download" ||
              response.data.status === "proccessing file" ||
              response.data.status === "Genrating File still in progress"
            ) {
              x.setState({ viewData: response.data.status });
              x.setState({
                ViewBoxDetails: true,
              });
            } else if (response.data.status === "ready to download") {
              clearInterval(callexport);
              x.setState({ viewData: response.data.status });

              var collectionName = response.data.file_name;
              if (ip.includes(s2)) {
                window.location =
                  API_BASE_URL + "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              } else {
                window.location =
                  API_BASE_URL +
                  "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              }
              x.setState({
                ViewBoxDetails: false,
              });
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
          } else {
            console.log("Something wrong");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, 3000);
  };

  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".yellow_color").style =
        "float:right;white-space: pre;";
      if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
        document.querySelector(".search_web ").style =
          "margin-right: 57%; margin-top: 1%;";
      } else {
      }
      // document.querySelector(".icon2 ").style = "float:left !important;";
      document.querySelector(".table").style = "width: 95%;margin-right: 2.5%;";
      // document.querySelector(".th_child").style = "text-align: right;";
      //document.querySelector(".th_child1").style = "text-align: right;";
      //document.querySelector(".th_child2").style = "text-align: right;";
      document.querySelector(".ui.pagination.menu").style =
        "float: left !important; margin-left: 7% !important;";
      document.querySelector(".fixed_bulk").style =
        "margin-right: 0% !important;";
      var x = window.matchMedia("(max-width: 700px)");
      this.myFunction(x);
    }
  }
  myFunction = (x) => {
    if (x.matches) {
      // If media query matches
      //document.querySelector(".icon_mobile").style =
      //"float: left;margin-top: 12%; width: 24%;cursor: pointer;margin-left: -5%;";
    } else {
      //            document.querySelector('.icon_mobile').style = 'float: left;margin-top: 1%;width: 5%;cursor: pointer; margin-left: -5%;';
    }
  };

  exportData = (e) => {
    setInterval(this.exportDataTimer(), 5000);
    //document.querySelector(".viewBox").style = "display:block";
  };

  exportDetalis = (e) => {
    setInterval(this.export_details(), 3000);
  };

  exportDataTimer() {
    // document.querySelector(".viewBox").style = "display:block";

    var x = this;
    x.setState({
      displayViewBox: true,
    });
    var user_id = reactLocalStorage.get("user_id_login");
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_jobs";
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      var query = { file_id: user_id, service_type: "bulk_sms" };
    } else {
      var query = {
        file_id: user_id,
        user_id: user_id,
        service_type: "bulk_sms",
      };
    }
    query = encodeURI(JSON.stringify(query));
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" +
        collectionName +
        "?query=" +
        query;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/Export/" +
        collectionName +
        "?query=" +
        query;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };

    axios
      .get(apiBaseUrl, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.status != "ready to download" ||
            response.data.status === "proccessing file" ||
            response.data.status === "Genrating File still in progress"
          ) {
            //document.querySelector(".viewBox").style = "display:block";
            x.setState({
              displayViewBox: true,
            });
            x.exportDataTimerInterval();
            x.setState({ viewData: response.data.status });
          } else if (response.data.status === "ready to download") {
            //  document.querySelector(".viewBox").style = "display:none";

            x.setState({ viewData: response.data.status });

            var collectionName = response.data.file_name;
            console.log("calling here");
            if (ip.includes(s2)) {
              window.location =
                API_BASE_URL + "/core/user/rest/Export/" +
                collectionName +
                "/download";
            } else {
              window.location =
                API_BASE_URL +
                "/core/user/rest/Export/" +
                collectionName +
                "/download";
            }
            x.setState({
              displayViewBox: false,
            });
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  exportDataTimerInterval() {
    var x = this;
    var user_id = reactLocalStorage.get("user_id_login");
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_jobs";
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      var query = { file_id: user_id, service_type: "bulk_sms" };
    } else {
      var query = {
        file_id: user_id,
        user_id: user_id,
        service_type: "bulk_sms",
      };
    }
    query = encodeURI(JSON.stringify(query));
    var callexport = setInterval(function() {
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/Export/" +
          collectionName +
          "?query=" +
          query;
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/Export/" +
          collectionName +
          "?query=" +
          query;
      }
      var headers = {
        "Content-Type": "application/json",
        token: token,
      };

      axios
        .get(apiBaseUrl, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (
              response.data.status != "ready to download" ||
              response.data.status === "proccessing file" ||
              response.data.status === "Genrating File still in progress"
            ) {
              document.querySelector(".viewBox").style = "display:block";
              x.setState({ viewData: response.data.status });
            } else if (response.data.status === "ready to download") {
              clearInterval(callexport);
              document.querySelector(".viewBox").style = "display:none";
              x.setState({ viewData: response.data.status });
              var collectionName = response.data.file_name;
              if (ip.includes(s2)) {
                window.location =
                  API_BASE_URL + "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              } else {
                window.location =
                  API_BASE_URL +
                  "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              }
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
          } else {
            console.log("Something wrong");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, 5000);
  }

  //////////////////////// from add bulk sms /////////////////////////
  goToAddBulkSMS() {
    this.findAllContact();
    this.setState({ modalOpenBulkSMSStepOne: true });
    this.setState({
      title: "",
      senderidselect: "",
      typeofMSg: "",
      nameoftype: "",
    });
    var lang = i18n.language;

    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".yellow_color").style =
        "float:right;margin-right: 15%;white-space: pre;";
      // document.querySelector(".Logo_auth").style = "float:left;";
      //  document.querySelector(".bulk_add_card").style =
      //  "text-align: right;float:left;";
      //document.querySelector(".btn_eng").style = "display:none;";
      //document.querySelector(".btn_ar").style = "display:block;";
      //document.querySelector(".btn_eng_step2").style = "display:none;";
      //document.querySelector(".btn_ar_step2").style = "display:block;";
      //document.querySelector(".btn_eng_step3").style = "display:none;";
      //document.querySelector(".btn_ar_step3").style = "display:block;";
    } else {
      //document.querySelector(".Logo_auth").style = "float:right;";
    }

    /////////////////////////////////////////////////////////////////////////////////////
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    }
    countryOptions = [];

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.sender_ids != undefined) {
        const senderidoption = res.data.result.sender_ids;
        var length = res.data.result.sender_ids.length;
        var i;
        var newArr = [];
        //  newArr = this.state.options_sender;
        for (i = 0; i < length; i++) {
          var value_option = senderidoption[i].sender_id;

          newArr.push({
            label: value_option,
            value: senderidoption[i].id,
          });
        }
        this.setState({ options_sender: res.data.result.sender_ids });
        console.log(newArr, "newArr");
        this.setState({ countryOptions: newArr });

        countryOptions = newArr;
      }
    });

    // get groups id
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/getGroups";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/getGroups";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data != undefined && res.data.result.groups != undefined) {
        const dataoption = res.data.result.groups;
        var length = res.data.result.groups.length;
        var i;
        const newArr = this.state.options_senders;
        for (i = 0; i < length; i++) {
          var value_option = dataoption[i].group_name;

          newArr.push({
            label: value_option,
            value: dataoption[i].id,
          });
        }
        groupOptions = newArr;
      }
    });

    // to get categories
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/findAllCategories";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/" +
        reactLocalStorage.get("user_id_login") +
        "/findAllCategories";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const persons = res.data.result.Categories;
      var i;
      var newArr = [];
      if (persons != undefined) {
        for (i = 0; i < res.data.result.Categories.length; i++) {
          var value_option = res.data.result.Categories[i].category_name;

          newArr.push({
            label: value_option,
            value: res.data.result.Categories[i].id,
          });
        }
        categoryOptions = newArr;
      }
    });

    // to get templates
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = -1;
    var search = "";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result != undefined) {
        var i;

        var i;
        const newArr = [];
        for (i = 0; i < res.data.result.templates.length; i++) {
          var value_option = res.data.result.templates[i].template_name;

          newArr.push({
            label: value_option,
            value: res.data.result.templates[i].template_value,
          });
        }

        template = newArr;
      }
    });
  }

  findAllContact() {
    var token = reactLocalStorage.get("accessToken");
    reactLocalStorage.get("user_id_login");
    var page_num = this.state.activePage - 1;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        page_num +
        "/findallcontacts";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        page_num +
        "/findallcontacts";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const persons = res.data.result.contacts;
      var totalContactspages = Math.ceil(res.data.result.total_contacts / 20);
      this.setState({ contacttotalpage: totalContactspages });
      if (res.data.result.contacts != undefined) {
        this.setState({ persons });
      }
    });
  }

  onChangedatetime = (date) => {
    date = new Date(date);
    this.setState({ date });
  };

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    this.subtitle.style.color = "#f00";
  }

  openModalSchedule() {
    this.setState({ modalIsOpenScheule: true });
  }

  afterOpenModalSchedule() {
    this.subtitle.style.color = "#f00";
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
    this.setState({
      title: "",
      typeofMSg: "",
      content: "",
      send_now: true,
      senderidselect: "",
      groups_id: [],
      items: [],
      items2: [],
    });
    data.delete("file");
    data.delete("object");
    window.location = "bulk";
  }

  afterOpenModalContact() {}

  closeModalSchedule() {
    this.setState({ modalIsOpenScheule: false });
    window.location = "ReportBulk";
  }

  searchchangeAdd = (event) => {
    if (event.target.value != "") {
      document.querySelector(".contactPagination").style = "display:none";
      document.querySelector(".searchcontactPagination").style = "display:none";
      var token = reactLocalStorage.get("accessToken");

      reactLocalStorage.get("user_id_login");

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/" +
          event.target.value +
          "/searchContacts";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/contacts/" +
          reactLocalStorage.get("user_id_login") +
          "/" +
          event.target.value +
          "/searchContacts";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        if (res.data.result.contacts != undefined) {
          const persons = res.data.result.contacts;
          this.setState({
            searchcontacttotalpage: Math.ceil(
              res.data.result.contacts_count / 20
            ),
          });

          this.setState({ persons });
        }
      });
    } else {
      this.findAllContact();
    }
  };
  handleChangeTitle = (event) => {
    //  document.querySelector('.title_data').style='border-color:#ced4da';
    this.setState({ title: event.target.value }, function() {});
  };

  isProbablyEnglish(str) {
    var index;

    for (index = str.length - 1; index >= 0; index--) {
      if (ENGLISH.indexOf(str.substring(index, index + 1)) < 0) {
        return false;
      }
    }
    return true;
  }
  /*******************Fast Track 11-7-2023 ***************************  */
  handleChangeContent = (event) => {
    document.querySelector(".textarea_content").style = "border-color:#ced4da";
    this.setState({ content: event.target.value });

    var flag = this.isProbablyEnglish(this.state.content);
    console.log(this.isProbablyEnglish(this.state.content));
    if (flag === false) {
      if (event.target.value.length < 70) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 1 });
      }
      if (event.target.value.length == 70) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 1 });
      }
      if (event.target.value.length > 70 && event.target.value.length <= 134) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 2 });
      }
      if (event.target.value.length > 134 && event.target.value.length <= 201) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 3 });
      }
      if (event.target.value.length > 201 && event.target.value.length <= 268) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 4 });
      }
      if (event.target.value.length > 268 && event.target.value.length <= 335) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 5 });
      }

      if (event.target.value.length > 335 && event.target.value.length <= 402) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 6 });
      }
      if (event.target.value.length > 402 && event.target.value.length <= 469) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 7 });
      }
      if (event.target.value.length > 469 && event.target.value.length <= 536) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 8 });
      }
      if (event.target.value.length > 536 && event.target.value.length <= 603) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 9 });
      }
      if (event.target.value.length > 603 && event.target.value.length <= 670) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 10 });
      }

      if (event.target.value.length > 670) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessages: 11 });
        /* var num = Math.ceil(event.target.value.length / 67);
    
        this.setState({ numberOfMessages: num });*/
      }
      if (event.target.value.length > 671) {
        console.log(event.target.value.length);
        var num = Math.ceil(event.target.value.length / 55);
        this.setState({ numberOfMessages: num });
      }
    } else if (flag === true) {
      if (event.target.value.length.length < 160) {
        this.setState({ numberOfMessages: 1 });
      }
      if (event.target.value.length == 160) {
        this.setState({ numberOfMessages: 1 });
      }
      if (event.target.value.length > 160 && event.target.value.length <= 306) {
        this.setState({ numberOfMessages: 2 });
      }
      if (event.target.value.length > 306 && event.target.value.length <= 459) {
        this.setState({ numberOfMessages: 3 });
      }
      if (event.target.value.length > 459 && event.target.value.length <= 612) {
        this.setState({ numberOfMessages: 4 });
      }
      if (event.target.value.length > 612 && event.target.value.length <= 765) {
        this.setState({ numberOfMessages: 5 });
      }

      if (event.target.value.length > 765 && event.target.value.length <= 918) {
        this.setState({ numberOfMessages: 6 });
      }
      if (
        event.target.value.length > 918 &&
        event.target.value.length <= 1071
      ) {
        this.setState({ numberOfMessages: 7 });
      }
      if (
        event.target.value.length > 1071 &&
        event.target.value.length <= 1224
      ) {
        this.setState({ numberOfMessages: 8 });
      }
      if (
        event.target.value.length > 1224 &&
        event.target.value.length <= 1377
      ) {
        this.setState({ numberOfMessages: 9 });
      }
      if (
        event.target.value.length > 1377 &&
        event.target.value.length <= 1530
      ) {
        this.setState({ numberOfMessages: 10 });
      }
      if (event.target.value.length > 1530) {
        this.setState({ numberOfMessages: 11 });
      }
      if (event.target.value.length > 1531) {
        var num = Math.ceil(event.target.value.length / 12);
        // var num =num_calc +1 ;

        console.log("Number of message in English");
        console.log(num);
        this.setState({ numberOfMessages: num });
      }
    }
    // if (event.target.value.includes("var_")) {
    //   count = event.target.value.split("var_").length - 1;
    // }

    // var ltrChars =
    //     "A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF" +
    //     "\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF",
    //   rtlChars = "\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC",
    //   rtlDirCheck = new RegExp("^[^" + ltrChars + "]*[" + rtlChars + "]");

    // if (rtlDirCheck.test(event.target.value) === true) {
    //   document.querySelector(".textarea__countar").style = "display:block";
    //   document.querySelector(".textarea__countar").style = "float:right";
    //   document.querySelector(".textarea__counten").style = "display:none";
    //   var textCount = event.target.value;

    //   if (textCount.length <= 70) {
    //     this.setState({ numberOfMessages: 1 });
    //   }
    //   if (textCount.length > 70 && textCount.length <= 134) {
    //     this.setState({ numberOfMessages: 2 });
    //   }
    //   if (textCount.length > 134 && textCount.length <= 201) {
    //     this.setState({ numberOfMessages: 3 });
    //   }

    //   if (textCount.length > 201) {
    //     var num = Math.ceil(textCount.length / 67);

    //     this.setState({ numberOfMessages: num });
    //   }
    // } else {
    //   document.querySelector(".textarea__countar").style = "display:none";
    //   document.querySelector(".textarea__counten").style = "display:block";
    //   document.querySelector(".textarea__counten").style = "float:right";
    //   var textCount = event.target.value;

    //   if (textCount.length <= 160) {
    //     this.setState({ numberOfMessages: 1 });
    //   }
    //   if (textCount.length > 160 && textCount.length <= 306) {
    //     this.setState({ numberOfMessages: 2 });
    //   }
    //   if (textCount.length > 306 && textCount.length <= 459) {
    //     this.setState({ numberOfMessages: 3 });
    //   }

    //   if (textCount.length > 459) {
    //     var num = Math.ceil(textCount.length / 153);

    //     this.setState({ numberOfMessages: num });
    //   }
    // }
  };

  handleChangeupload = (event) => {
    data.set("file", event.target.files[0]);
  };

  onChangevariables = (values) => {
    this.setState({ typeofvariable: values.value }, function() {});
    this.setState({ nameofvariable: values.label }, function() {});
    value_variables = this.state.content + " " + "{" + values.value + "}";
    this.setState({ content: value_variables });
  };

  onChange = (values) => {
    this.setState({ typeofMSg: values.value });
    this.setState({ nameoftype: values.label });

    if (values.label === "Number" || values.label === "رقم") {
      document.querySelector(".mobile_div").style = "display:block";
    } else {
      document.querySelector(".mobile_div").style = "display:none";
    }

    if (
      values.label === "File" ||
      values.label === "Dynamic File" ||
      values.label === "ملف" ||
      values.label === "ملف متغير" ||
      values.label === "Smart dynamic" ||
      values.label === "ديناميكية ذكية"
    ) {
      document.querySelector(".upload_div").style = "display:block";
    } else {
      document.querySelector(".upload_div").style = "display:none";
    }
    if (values.label === "Group" || values.label === "مجموعة") {
      document.querySelector(".group_div").style = "display:block";
      //  document.querySelector(".drop_variables").style = "display:block";
    } else {
      document.querySelector(".group_div").style = "display:none";
    }

    if (values.label === "Category" || values.label === "فئة") {
      document.querySelector(".category_div").style = "display:block";
      // document.querySelector(".drop_variables").style = "display:block";
    } else {
      document.querySelector(".category_div").style = "display:none";
    }

    if (values.label === "Contact List" || values.label === "قائمة الاتصال") {
      // document.querySelector(".contact_list_div").style = "display:block";
      // this.setState({modalOpenBulkSMSStepOne: false });
      this.setState({ modalOpenSellectContact: true });
    } else {
      //document.querySelector(".contact_list_div").style = "display:none";
      this.setState({ modalIsOpenContact: false });
    }

    if (values.label === "Smart dynamic" || values.label === "ديناميكية ذكية") {
      // document.querySelector(".add_variable_btn").style = "display:block";
      // document.querySelector(".textarea__counten_varaibles").style = "display:block";
    } else {
      //document.querySelector(".add_variable_btn").style = "display:none";
      // document.querySelector(".textarea__counten_varaibles").style = "display:none";
    }
  };

  onChangecontact(values) {
    this.setState({
      contactselect: values,
    });
  }
  onChangetime(values) {
    this.setState({
      timeselect: values,
    });
    if (values.label === "Schedule time" || values.label === "ضبط الوقت") {
      document.querySelector(".time_div").style = "display:block";
      this.setState({ send_now: false });
    } else {
      document.querySelector(".time_div").style = "display:none";
      this.setState({ send_now: true });
    }
  }

  onchangescheduledate = (event) => {
    this.setState({
      dateofsend: event.target.value,
    });
  };
  onchangeschedule = (event) => {
    this.setState({
      timeofsend: event.target.value,
    });
  };
  onChangesenderid = (event) => {
    this.setState({ senderidselect: event.label }, function() {});
  };
  openstep2 = () => {
    console.log(this.state.nameoftype, " this.state.nameoftype");
    if (this.state.title === "" || this.state.nameoftype === "") {
      //document.querySelector('.title_data').style='border-color:red';
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_title_field.label"),
        animation: "bounce",
        time: 5000,
      });
    } else {
      if (this.state.nameoftype == "Number") {
        console.log("meee");
        console.log(this.state.mobile);
        if (this.state.mobile == "" || this.state.mobile == undefined) {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Please_fill_title_field.label"),
            animation: "bounce",
            time: 5000,
          });
        } else {
          this.setState({
            modalOpenBulkSMSStepTow: true,
            modalOpenBulkSMSStepOne: false,
          });
        }
      } else {
        this.setState({
          modalOpenBulkSMSStepTow: true,
          modalOpenBulkSMSStepOne: false,
        });
      }
    }
  };

  openstep2() {
    this.setState({ title: "" }, function() {});

    this.setState({ typeofMSg: "" });
    this.setState({ mobile: "" });
    mobile = [];
    reactLocalStorage.set("mobile", mobile);
    this.setState({ nameoftype: "" });
    this.setState({ uploadfile: [] });
    this.setState({ groups_id: [] });

    data.delete("object");
    data.delete("file");
    this.setState({
      file: null,
      groups_id: [],
      length_category: 0,
      inputKey: Date.now(),
    });

    this.setState({ nameoftype: "" }, function() {});
  }

  openstep3 = () => {
    if (this.state.senderidselect != "") {
      document.querySelector(".step_three").style = "display:block";
      document.querySelector(".step_two").style = "display:none";
    } else {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        animation: "bounce",
        time: 5000,
      });
    }
    if (this.state.typeofMSg === "dynamic_file") {
      document.querySelectorAll(".templates-class").style =
        "display:none !important";
    }
    var lang = i18n.language;
    if (lang === "ar") {
      document.querySelector(".step_three").style = "text-align: right;";
    }
  };
  openstep22 = () => {
    if (back == "true") {
      document.querySelector(".bulk_add_card").style = "display:block";
      document.querySelector(".step_two").style = "display:none";
      document.querySelector(".step_three").style = "display:none";
      document.querySelector(".upload_div").style = "display:none";
      this.setState({ senderidselect: "" });
      data.delete("object");
      data.delete("file");
      this.setState({
        file: null,
        inputKey: Date.now(),
      });
      this.setState({ title: "" }, function() {});

      this.setState({ typeofMSg: "" });
      this.setState({ mobile: "" });
      mobile = [];
      reactLocalStorage.set("mobile", mobile);
      this.setState({ nameoftype: "" });
      this.setState({ uploadfile: null });
      document.getElementById("btn_submit_step3").disabled = false;
    } else {
      document.querySelector(".bulk_add_card").style = "display:none";
      document.querySelector(".step_two").style = "display:block";
      document.querySelector(".step_three").style = "display:none";
      document.getElementById("btn_submit_step3").disabled = false;
      this.setState({ senderidselect: "" });
      data.delete("object");
      data.delete("file");
    }
  };

  submit = (event) => {
    event.preventDefault();

    if (this.state.send_now === false) {
      var defaultDate = new Date();
      if (this.state.date >= defaultDate) {
        if (
          this.state.content === "" &&
          this.state.typeofMSg !== "dynamic_file"
        ) {
          document.querySelector(".textarea_content").style =
            "border-color:red";
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Please_fill_content_fields.label"),
            animation: "bounce",
            time: 5000,
          });
        } else if (
          this.state.content != "" ||
          this.state.typeofMSg === "dynamic_file"
        ) {
          let currentComponent = this;
          //document.getElementById("btn_submit_step3").disabled = true;
          //document.getElementById("btn_back_step3").disabled = true;
          var i;
          var array = [];
          for (i = 0; i < category_ids.length; i++) {
            array.push(category_ids[i].value);
          }
          var token = reactLocalStorage.get("accessToken");
          if (
            this.state.nameoftype === "Number" ||
            this.state.nameoftype === "رقم"
          ) {
            mobile = [];
            mobile.push(reactLocalStorage.get("mobile"));
          }

          if (
            this.state.nameoftype === "Contact List" ||
            this.state.nameoftype === "قائمة الاتصال"
          ) {
            mobile = mobile;
          }

          var d = this.state.date;
          var month = d.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          var hour = d.getHours();
          if (hour < 10) {
            hour = "0" + hour;
          }
          var date = d.getDate();
          if (date < 10) {
            date = "0" + date;
          }
          var minutes = d.getMinutes();
          if (minutes < 10) {
            minutes = "0" + minutes;
          }
          var dformat =
            [d.getFullYear(), month, date].join("-") +
            "T" +
            [hour, minutes, d.getSeconds() + "0"].join(":") +
            "Z";

          var date_time = dformat;
          var groups_id = this.state.groups_id;
          var i;
          var array2 = [];
          for (i = 0; i < this.state.groups_id.length; i++) {
            array2.push(groups_id[i].value);
          }
          if (
            this.state.nameoftype === "Group" ||
            (this.state.nameoftype === "مجموعة" &&
              this.state.send_now === false)
          ) {
            var test = new Blob(
              [
                JSON.stringify({
                  recipient_numbers_type: this.state.typeofMSg,
                  content: this.state.content,
                  service_type: "bulk_sms",
                  send_now: this.state.send_now,
                  sender_id: this.state.senderidselect,
                  groups_id: array2,
                  add_numbers: this.state.items,
                  remove_numbers: this.state.items2,
                  schedule_date: date_time,
                  title: this.state.title,
                  recurring: this.state.selectedDays,
                }),
              ],
              { type: "application/json" }
            );
            data.append("object", test);
          } else if (
            this.state.nameoftype === "Group" ||
            (this.state.nameoftype === "مجموعة" && this.state.send_now === true)
          ) {
            var test = new Blob(
              [
                JSON.stringify({
                  recipient_numbers_type: this.state.typeofMSg,
                  content: this.state.content,
                  service_type: "bulk_sms",
                  send_now: this.state.send_now,
                  sender_id: this.state.senderidselect,
                  groups_id: array2,
                  add_numbers: this.state.items,
                  remove_numbers: this.state.items2,
                  title: this.state.title,
                  recurring: this.state.selectedDays,
                }),
              ],
              { type: "application/json" }
            );
            data.append("object", test);
          } else if (
            this.state.nameoftype === "Category" ||
            (this.state.nameoftype === "فئة" && this.state.send_now === true)
          ) {
            var test = new Blob(
              [
                JSON.stringify({
                  recipient_numbers_type: this.state.typeofMSg,
                  content: this.state.content,
                  service_type: "bulk_sms",
                  send_now: this.state.send_now,
                  sender_id: this.state.senderidselect,
                  groups_id: array,
                  add_numbers: this.state.items,
                  remove_numbers: this.state.items2,
                  title: this.state.title,
                  recurring: this.state.selectedDays,
                }),
              ],
              { type: "application/json" }
            );
            data.append("object", test);
          } else if (
            this.state.nameoftype === "Category" ||
            (this.state.nameoftype === "فئة" && this.state.send_now === false)
          ) {
            var test = new Blob(
              [
                JSON.stringify({
                  recipient_numbers_type: this.state.typeofMSg,
                  content: this.state.content,
                  service_type: "bulk_sms",
                  send_now: this.state.send_now,
                  sender_id: this.state.senderidselect,
                  groups_id: array,
                  add_numbers: this.state.items,
                  remove_numbers: this.state.items2,
                  schedule_date: date_time,
                  title: this.state.title,
                  recurring: this.state.selectedDays,
                }),
              ],
              { type: "application/json" }
            );
            data.append("object", test);
          } else if (this.state.send_now === false) {
            var test = new Blob(
              [
                JSON.stringify({
                  recipient_numbers_type: this.state.typeofMSg,
                  content: this.state.content,
                  service_type: "bulk_sms",
                  send_now: this.state.send_now,
                  sender_id: this.state.senderidselect,
                  phone_numbers: mobile,
                  schedule_date: date_time,
                  title: this.state.title,
                  recurring: this.state.selectedDays,
                }),
              ],
              { type: "application/json" }
            );
            data.append("object", test);
          } else if (this.state.send_now === true) {
            var test = new Blob(
              [
                JSON.stringify({
                  recipient_numbers_type: this.state.typeofMSg,
                  content: this.state.content,
                  service_type: "bulk_sms",
                  send_now: this.state.send_now,
                  sender_id: this.state.senderidselect,
                  phone_numbers: mobile,
                  title: this.state.title,
                  recurring: this.state.selectedDays,
                }),
              ],
              { type: "application/json" }
            );
            data.append("object", test);
          }
          this.setState({ disabledButton: true });

          var ip = API_BASE_URL;
          var s2 = "localhost:3000";
          var apiBaseUrl;
          if (ip.includes(s2)) {
            apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
          } else {
            apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
          }

          axios
            .post(apiBaseUrl, data, {
              headers: { "Content-Type": "multipart/form-data", token: token },
            })
            .then(function(response) {
              currentComponent.setState({ disabledButton: false });
              if (response.status === 200) {
                var result = response.data.result;

                if (
                  result != undefined &&
                  response.data.status == "send confirm!"
                ) {
                  currentComponent.setState({
                    resultall: response.data.result.valid_numbers_count,
                  });

                  currentComponent.setState({
                    confirm_id: response.data.result.confirm_id,
                  });

                  currentComponent.setState({
                    resultallinvalid:
                      response.data.result.invalid_numbers_count,
                  });
                  currentComponent.setState({
                    totalduplicate:
                      response.data.result.total_duplicate_numbers != null
                        ? response.data.result.total_duplicate_numbers
                        : 0,
                  });
                  currentComponent.setState({
                    callbackDataValid: response.data.result.valid_numbers,
                  });
                  currentComponent.setState({
                    totalmsg: response.data.result.total_messages,
                  });
                  currentComponent.setState({
                    balance_reserved:
                      response.data.result.balance_reserved.bulk_sms,
                  });
                  currentComponent.setState({
                    callbackDataInValid: response.data.result.invalid_numbers,
                  });

                  currentComponent.setState({ modalOpenConfirm: true });
                  currentComponent.setState({ confirm: result.confirm_id });
                } else {
                  toast({
                    type: "warning",
                    title: i18n.t("warning.label"),
                    description: response.data.status,
                    animation: "bounce",
                    time: 5000,
                  });
                  // document.getElementById("btn_back_step3").disabled = false;
                }
                data.delete("file");
                data.delete("object");

                back = "true";
              } else if (response.status === 204) {
                console.log("Something wrong");
                toast({
                  type: "error",
                  title: i18n.t("error.label"),
                  description: i18n.t("Something_wrong.label"),
                  animation: "bounce",
                  time: 5000,
                });
                // document.getElementById("btn_back_step3").disabled = false;
              }
            })
            .catch(function(error) {
              console.log(error);
              toast({
                type: "error",
                title: i18n.t("error.label"),
                description: i18n.t("Something_wrong.label"),
                animation: "bounce",
                time: 5000,
              });
              // document.getElementById("btn_back_step3").disabled = false;
            });
        } else {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Please_fill_all_fields.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      } else {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_choose_avalid_time.label"),
          animation: "bounce",
          time: 5000,
        });
      }
    } else {
      if (
        this.state.content === "" &&
        this.state.typeofMSg !== "dynamic_file"
      ) {
        document.querySelector(".textarea_content").style = "border-color:red";
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_content_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      } else if (
        this.state.content != "" ||
        this.state.typeofMSg === "dynamic_file"
      ) {
        let currentComponent = this;
        // document.getElementById("btn_submit_step3").disabled = true;
        //document.getElementById("btn_back_step3").disabled = true;
        var i;
        var array = [];
        for (i = 0; i < category_ids.length; i++) {
          array.push(category_ids[i].value);
        }
        var token = reactLocalStorage.get("accessToken");
        if (
          this.state.nameoftype === "Number" ||
          this.state.nameoftype === "رقم"
        ) {
          mobile = [];

          mobile.push(reactLocalStorage.get("mobile"));
        }

        if (
          this.state.nameoftype === "Contact List" ||
          this.state.nameoftype === "قائمة الاتصال"
        ) {
          mobile = mobile;
        }

        var d = this.state.date;
        var month = d.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var hour = d.getHours();
        if (hour < 10) {
          hour = "0" + hour;
        }
        var date = d.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        var minutes = d.getMinutes();
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        var dformat =
          [d.getFullYear(), month, date].join("-") +
          "T" +
          [hour, minutes, d.getSeconds() + "0"].join(":") +
          "Z";

        var date_time = dformat;
        var groups_id = this.state.groups_id;
        var i;
        var array2 = [];
        for (i = 0; i < this.state.groups_id.length; i++) {
          array2.push(groups_id[i].value);
        }
        if (
          this.state.nameoftype === "Group" ||
          (this.state.nameoftype === "مجموعة" && this.state.send_now === false)
        ) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                groups_id: array2,
                add_numbers: this.state.items,
                remove_numbers: this.state.items2,
                schedule_date: date_time,
                title: this.state.title,
                recurring: this.state.selectedDays,
              }),
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        } else if (
          this.state.nameoftype === "Group" ||
          (this.state.nameoftype === "مجموعة" && this.state.send_now === true)
        ) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                groups_id: array2,
                add_numbers: this.state.items,
                remove_numbers: this.state.items2,
                title: this.state.title,
                recurring: this.state.selectedDays,
              }),
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        } else if (
          this.state.nameoftype === "Category" ||
          (this.state.nameoftype === "فئة" && this.state.send_now === true)
        ) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                groups_id: array,
                add_numbers: this.state.items,
                remove_numbers: this.state.items2,
                title: this.state.title,
                recurring: this.state.selectedDays,
              }),
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        } else if (
          this.state.nameoftype === "Category" ||
          (this.state.nameoftype === "فئة" && this.state.send_now === false)
        ) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                groups_id: array,
                add_numbers: this.state.items,
                remove_numbers: this.state.items2,
                schedule_date: date_time,
                title: this.state.title,
                recurring: this.state.selectedDays,
              }),
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        } else if (this.state.send_now === false) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                phone_numbers: mobile,
                schedule_date: date_time,
                title: this.state.title,
                recurring: this.state.selectedDays,
              }),
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        } else if (this.state.send_now === true) {
          var test = new Blob(
            [
              JSON.stringify({
                recipient_numbers_type: this.state.typeofMSg,
                content: this.state.content,
                service_type: "bulk_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                phone_numbers: mobile,
                title: this.state.title,
                recurring: this.state.selectedDays,
              }),
            ],
            { type: "application/json" }
          );
          data.append("object", test);
        }
        this.setState({disabledButton:true})
        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
        } else {
          apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
        }

        axios
          .post(apiBaseUrl, data, {
            headers: { "Content-Type": "multipart/form-data", token: token },
          })
          .then(function(response) {
            currentComponent.setState({ disabledButton: false });
            if (response.status === 200) {
              var result = response.data.result;

              if (
                result != undefined &&
                response.data.status === "send confirm!"
              ) {
                currentComponent.setState({
                  resultall: response.data.result.valid_numbers_count,
                });

                currentComponent.setState({
                  confirm_id: response.data.result.confirm_id,
                });

                currentComponent.setState({
                  resultallinvalid: response.data.result.invalid_numbers_count,
                });
                currentComponent.setState({
                  totalduplicate:
                    response.data.result.total_duplicate_numbers != null
                      ? response.data.result.total_duplicate_numbers
                      : 0,
                });
                currentComponent.setState({
                  callbackDataValid: response.data.result.valid_numbers,
                });
                currentComponent.setState({
                  totalmsg: response.data.result.total_messages,
                });
                currentComponent.setState({
                  balance_reserved:
                    response.data.result.balance_reserved.bulk_sms,
                });
                currentComponent.setState({
                  callbackDataInValid: response.data.result.invalid_numbers,
                });

                currentComponent.setState({ modalOpenConfirm: true });
                console.log("iam there");
                currentComponent.setState({ confirm: result.confirm_id });
              } else {
                toast({
                  type: "warning",
                  title: i18n.t("warning.label"),
                  description: response.data.status,
                  animation: "bounce",
                  time: 5000,
                });
                // document.getElementById("btn_back_step3").disabled = false;
              }
              data.delete("file");
              data.delete("object");

              back = "true";
            } else if (response.status === 204) {
              console.log("Something wrong");
              toast({
                type: "error",
                title: i18n.t("error.label"),
                description: i18n.t("Something_wrong.label test"),
                animation: "bounce",
                time: 5000,
              });
              // document.getElementById("btn_back_step3").disabled = false;
            }
          });
        /* .catch(function(error) {
            console.log(error);
            toast({
              type: 'error',
              title: i18n.t('error.label'),
              description:i18n.t('Something_wrong.label test2'),
              animation: 'bounce',
              time: 5000,
  
          });
          //document.getElementById("btn_back_step3").disabled = false;
          }); */
      } else {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_all_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      }
    }
  };

  closemodalcontact = () => {
    this.setState({ modalIsOpenContact: false });
  };
  confirm_msg = (event) => {
    event.preventDefault();
    document.getElementById("confirm_sms").disabled = true;
    let currentComponent = this;
    var token = reactLocalStorage.get("accessToken");
    var confirm = this.state.confirm;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/confirmSMS/" +
        confirm;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/confirmSMS/" + confirm;
    }

    var data = {};
    axios
      .post(apiBaseUrl, data, {
        headers: { "Content-Type": "application/json", token: token },
      })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.result != undefined) {
            if (response.data.status === "saved successfully!") {
              currentComponent.setState({ modalOpenConfirm: false });
              window.location = "ReportBulk";
              // currentComponent.setState({ modalIsOpenScheule : true });
            } else {
              toast({
                type: "warning",
                title: i18n.t("warning.label"),
                description: response.data.status,
                animation: "bounce",
                time: 5000,
              });
            }
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      });
  };
  handleChangeMobile = (value) => {
    document.querySelector(".phone").style = "paddingLeft:50px";
    mobile = value;
    this.setState({ mobile: mobile });
    reactLocalStorage.set("mobile", mobile);
  };
  addNumber = (event) => {
    var mobiles = event.target.id;
    var newArray = mobile;
    if (newArray.includes(mobiles) === false) {
      newArray.push(event.target.id);
    } else {
      var index = newArray.indexOf(event.target.id);
      if (index != -1) {
        newArray.splice(index, 1);
      }
    }
    mobile = newArray;

    reactLocalStorage.set("mobiles", mobile);
  };

  onChangetemplate = (event) => {
    value_variables_one = this.state.content + " " + event.value;
    this.setState({ content: value_variables_one });
  };
  onChangegroup = (event) => {
    this.setState({ groups_id: event }, function() {});
  };
  onChangecategory = (event) => {
    this.setState({ length_category: event.length });

    var i;
    var category;
    for (i = 0; i < event.length; i++) {
      category = event[i].label;

      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/contacts/findAllCategoriesWithGroups";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/contacts/findAllCategoriesWithGroups";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        if (res.data != undefined) {
          const dataoption = res.data.result.CategoriesWithGroups;

          var result = dataoption[category];
          var i;

          for (i = 0; i < result.length; i++) {
            array_data.push({
              label: result[i].group_name,
              value: result[i].id,
            });
          }
          categoryGroupOptions = array_data;

          var value = this.state.title;
          this.setState({ title: value });
        }
      });
    }
  };

  handlePaginationAddChange = (e, { activePage }) => {
    this.setState({ activePage });
    var token = reactLocalStorage.get("accessToken");
    reactLocalStorage.get("user_id_login");
    var contactspagenumber = 0;
    contactspagenumber = activePage - 1;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        contactspagenumber +
        "/findallcontacts";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/contacts/user=" +
        reactLocalStorage.get("user_id_login") +
        "/page=" +
        contactspagenumber +
        "/findallcontacts";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const persons = res.data.result.contacts;
      var totalContactspages = res.data.result.total_contacts / 20;
      this.setState({ totalpage: totalContactspages });
      if (res.data.result.contacts != undefined) {
        this.setState({ persons });
      }
    });
  };

  handleInputChange(evt) {
    this.setState({ input: evt.target.value });
  }

  handleInputKeyDown(evt) {
    if (evt.keyCode === 13 || this.state.input.length == 12) {
      const { value } = evt.target;

      this.setState((state) => ({
        items: [...state.items, value],
        input: "",
      }));
    }

    if (
      this.state.items.length &&
      evt.keyCode === 8 &&
      !this.state.input.length
    ) {
      this.setState((state) => ({
        items: state.items.slice(0, state.items.length - 1),
      }));
    }
  }

  handleRemoveItem(index) {
    return () => {
      this.setState((state) => ({
        items: state.items.filter((item, i) => i != index),
      }));
    };
  }

  handleInputChange2(evt) {
    this.setState({ input2: evt.target.value });
  }

  handleInputKeyDown2(evt) {
    if (evt.keyCode === 13 || this.state.input2.length == 12) {
      const { value } = evt.target;

      this.setState((state) => ({
        items2: [...state.items2, value],
        input2: "",
      }));
    }

    if (
      this.state.items2.length &&
      evt.keyCode === 8 &&
      !this.state.input2.length
    ) {
      this.setState((state) => ({
        items2: state.items2.slice(0, state.items2.length - 1),
      }));
    }
  }

  handleRemoveItem2(index) {
    return () => {
      this.setState((state) => ({
        items2: state.items2.filter((item, i) => i != index),
      }));
    };
  }
  onChangecategoryGroup = (event) => {
    category_ids = event;
  };
  viewcategoryGroupOptions = () => {
    if (categoryGroupOptions != []) {
      return categoryGroupOptions;
    }
  };
  addVariables = () => {
    var content_data = this.state.content;
    var new_data = "";
    if (content_data.length > 0) {
      if (content_data.includes("var_")) {
        count = count + 1;

        new_data = content_data + " " + "{var_" + count + "}";
        this.setState({ content: new_data });
      } else {
        new_data = content_data + " " + "{var_" + count + "}";
        this.setState({ content: new_data });
      }
    }
  };

  goBack() {
    this.setState({
      modalOpenBulkSMSStepOne: true,
      modalOpenBulkSMSStepTow: false,
    });
  }

  showMobigram() {
    // document.getElementsByClassName(".mobigram").style='display:block'

    if (document.querySelector(".mobigram").style.display === "none") {
      document.querySelector(".mobigram").style = "display:block";
    } else {
      document.querySelector(".mobigram").style = "display:none";
    }
  }

  showRecurring() {
    if (document.querySelector(".recurring").style.display === "none") {
      document.querySelector(".recurring").style = "display:block";
    } else {
      document.querySelector(".recurring").style = "display:none";
    }
  }
  setTextAreaValue(data) {
    // if(reactLocalStorage.get('url')!= undefined){
    document.querySelector("contentArea").value += data;
  }
  //}

  handleSubmitEditor = (value) => {
    this.setState({
      loading: true,
    });
    const val = value;

    var data = {
      base64html: encode(value),
    };

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;

    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/general/mobigram";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/general/mobigram";
    }

    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            loading: false,
          });
          if (response.data.result != undefined) {
            if (response.data.status === "success") {
              var result = response.data.result.url;
              console.log(result);

              // let url = result.replace("isms", "solutions1");
              let url = result;
              console.log(url);
              //let url = result;
              //window.open(url, "_blank");
              // reactLocalStorage.set("url", url);
              //document.querySelector("contentArea").value=url
              document.getElementById("contentArea").value += url;
              this.setState({
                content: document.getElementById("contentArea").value,
              });
              //this.setTextAreaValue(url);
            } else {
              toast({
                type: "warning",
                title: i18n.t("warning.label"),
                description: response.data.status,
                animation: "bounce",
                time: 5000,
              });
            }
          }
        } else if (response.status === 204) {
          this.setState({
            loading: false,
          });
          console.log("Something wrong");

          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        } else {
          this.setState({
            loading: false,
          });
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      .catch(function(error) {
        this.setState({
          loading: false,
        });
        console.log(error);
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      });
  };

  openEdit = (event) => {
    var id = event.target.id;
    this.setState({
      msg_id: id,
      modalOpenBulkEdit: true,
    });
    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage - 1;
    var data = {
      searchQuery: "",
      page: page_num,
      service_type: "bulk_sms",
    };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.count / 20);

      console.log(total);
      this.setState({ bulktotalpage: total });

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }

      if (res.data.result.jobs != undefined) {
        for (i = 0; i < res.data.result.jobs.length; i++) {
          if (res.data.result.jobs[i].id === id) {
            var d = new Date(res.data.result.jobs[i].schedule_date),
              dformat =
                [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
                " " +
                [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
            //array.push({ date: dformat });

            this.setState({
              content: res.data.result.jobs[i].content,
              send_now: res.data.result.jobs[i].send_now,
              date: dformat,
            });
          }
        }
      }
      var i, j;

      var array = [];
      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });
  };

  submitEdit() {
    if (this.state.send_now === false) {
      var token = reactLocalStorage.get("accessToken");
      var defaultDate = new Date();
      if (this.state.date >= defaultDate) {
        if (this.state.content != "") {
          var d = this.state.date;
          var month = d.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          var hour = d.getHours();
          if (hour < 10) {
            hour = "0" + hour;
          }
          var date = d.getDate();
          if (date < 10) {
            date = "0" + date;
          }
          var minutes = d.getMinutes();
          if (minutes < 10) {
            minutes = "0" + minutes;
          }
          var dformat =
            [d.getFullYear(), month, date].join("-") +
            "T" +
            [hour, minutes, d.getSeconds() + "0"].join(":") +
            "Z";
          var data = {
            content: this.state.content,

            send_now: this.state.send_now,

            schedule_date: dformat,
            job_id: this.state.msg_id,
          };

          var ip = API_BASE_URL;

          var s2 = "localhost:3000";
          var apiBaseUrl;
          if (ip.includes(s2)) {
            apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/updateJob";
          } else {
            apiBaseUrl =
              API_BASE_URL + `/core/user/rest/jobs/updateJob`;
          }

          var headers = { "Content-Type": "application/json", token: token };
          axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
            if (res.status === 200) {
              if (res.data.status === "success") {
                window.location = "ReportBulk";
              }
            }
          });
        } else {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Please_fill_all_fields.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      } else {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_choose_avalid_time.label"),
          animation: "bounce",
          time: 5000,
        });
      }
    } else {
      if (this.state.content === "") {
        document.querySelector(".textarea_content").style = "border-color:red";
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_content_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      } else if (this.state.content != "") {
        var token = reactLocalStorage.get("accessToken");
        var d = new Date();
        console.log(d);
        var month = d.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var hour = d.getHours();
        if (hour < 10) {
          hour = "0" + hour;
        }
        var date = d.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        var minutes = d.getMinutes();
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        var dformat =
          [d.getFullYear(), month, date].join("-") +
          "T" +
          [hour, minutes, d.getSeconds() + "0"].join(":") +
          "Z";

        var data = {
          content: this.state.content,

          send_now: this.state.send_now,
          job_id: this.state.msg_id,

          //schedule_date: dformat,
        };

        var ip = API_BASE_URL;

        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/updateJob";
        } else {
          apiBaseUrl =
            API_BASE_URL + `/core/user/rest/jobs/updateJob`;
        }

        var headers = { "Content-Type": "application/json", token: token };
        axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
          if (res.status === 200) {
            if (res.data.status === "success") {
              window.location = "ReportBulk";
            }
          }
        });
      } else {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_all_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      }
    }
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  pauseJob = (event) => {
    var token = reactLocalStorage.get("accessToken");
    var id = event.target.id;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/pauseResumeJob/${id}`;
    } else {
      apiBaseUrl =
        API_BASE_URL + `/core//user/rest/jobs/pauseResumeJob/${id}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.status === 200) {
        if (res.data.status === "success") {
          toast({
            type: "success",
            title: i18n.t("success.label"),
            description: "Job paused Successfully ",
            animation: "bounce",
            time: 5000,
          });
        }
      }
    });
  };

  resumeJob = (event) => {
    var token = reactLocalStorage.get("accessToken");
    var id = event.target.id;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/pauseResumeJob/${id}`;
    } else {
      apiBaseUrl =
        API_BASE_URL + `/core//user/rest/jobs/pauseResumeJob/${id}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.status === 200) {
        if (res.data.status === "success") {
          toast({
            type: "success",
            title: i18n.t("success.label"),
            description: "Job resumed Successfully ",
            animation: "bounce",
            time: 5000,
          });
        }
      }
    });
  };

  Close() {
    this.setState({
      modalOpenBulkSMSStepOne: false,
      modalOpenBulkSMSStepTow: false,
      modalOpenConfirm: false,
    });
  }
  render() {
    const {
      contactactivePage,
      searchcontactactivePage,
      bulkactivePage,
      searchbulkactivePage,
      detailActivePage,
      searchdetailActivePage,
    } = this.state;
    const { activePage_modal } = this.state;
    const { activePage_modal2 } = this.state;
    const { activeIndex } = this.state;
    const styles = {
      container: {
        border: "1px solid #ddd",
        padding: "5px",
        borderRadius: "5px",
      },

      items: {
        display: "inline-block",
        padding: "2px",
        border: "1px solid blue",
        fontFamily: "Helvetica, sans-serif",
        borderRadius: "5px",
        marginRight: "5px",
        cursor: "pointer",
      },

      input: {
        outline: "none",
        border: "none",
        fontSize: "14px",
        fontFamily: "Helvetica, sans-serif",
        width: " 520px !important",
      },
      items2: {
        display: "inline-block",
        padding: "2px",
        border: "1px solid blue",
        fontFamily: "Helvetica, sans-serif",
        borderRadius: "5px",
        marginRight: "5px",
        cursor: "pointer",
      },

      input2: {
        outline: "none",
        border: "none",
        fontSize: "14px",
        fontFamily: "Helvetica, sans-serif",
        width: " 520px !important",
      },
    };
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_sms">
            <div className="sms_main">
              <Grid columns={2} divided className="fixed_bulk">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style yellow_color">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>

                  <br />
                </Grid.Row>
              </Grid>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />

              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />

                <Divider horizontal>
                  {" "}
                  <Header as="h2" color="black">
                    <Icon name="mail outline" color="black" /> Bulk SMS{" "}
                  </Header>{" "}
                </Divider>
                {this.state.displayViewBox && (
                  <div className="viewBox ">
                    <Message icon className="download_box">
                      <Icon name="circle notched" loading />
                      <Message.Content>
                        <Message.Header>Wait for downloading</Message.Header>
                        {this.state.viewData}
                      </Message.Content>
                    </Message>
                  </div>
                )}
                <br />
                <div className="buttonsHeader">
                  <Input
                    size="small"
                    icon="search"
                    placeholder={
                      this.state.isArabic
                        ? "البحث عن المرسل أو المستخدم "
                        : "Search By SenderID or UserName"
                    }
                    color="black"
                    onChange={this.searchchangemain.bind(this)}
                    style={{ float: "right" }}
                  />

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenFilterDetails}
                  >
                    <Icon
                      name="sort amount up"
                      onClick={this.handleOpenFilterDetails}
                    />{" "}
                    {i18n.t("filter.label")}
                  </Button>
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={() => {
                      this.componentWillMount();
                    }}
                  >
                    <Icon name="refresh" />{" "}
                    {this.state.isArabic ? "تحديث" : "Refresh"}
                  </Button>

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    disabled={this.state.exportFlag === false ? true : false}
                    size="small"
                    onClick={this.exportData}
                  >
                    <Icon name="file excel" /> {i18n.t("export.label")}
                  </Button>

                  {reactLocalStorage.get("role") === "ROLE_ADMIN" ||
                  reactLocalStorage.get("role") === "ROLE_SUBADMIN" ? (
                    <Button
                      floated="right"
                      icon
                      labelPosition="left"
                      basic
                      size="small"
                      onClick={() => {
                        this.goToAddBulkSMS();
                      }}
                    >
                      {this.state.isArabic
                        ? "Bulk انشاء رسالة"
                        : "Compose Bulk SMS"}
                      <Icon
                        name="pencil alternate"
                        color="black"
                      />
                    </Button>
                  ) : (
                    ""
                  )}
                  {reactLocalStorage.get("packageID") === "1692" ? null : (
                    <Button.Group>
                      <Button color="teal" basic>
                        <Icon name="bell" />
                        {this.state.isArabic
                          ? "الرصيد المتبقي"
                          : "Remaining Balance "}
                      </Button>
                      {this.state.isArabic ? (
                        <Button color="teal">
                          {commaNumber(this.state.bulk_balance) != null
                            ? commaNumber(this.state.bulk_balance) + " رسالة "
                            : "-"}
                        </Button>
                      ) : (
                        <Button color="teal">
                          {commaNumber(this.state.bulk_balance) != null
                            ? commaNumber(this.state.bulk_balance) + " SMS"
                            : "-"}
                        </Button>
                      )}
                    </Button.Group>
                  )}
                </div>

                <br />
                <br />
                <br />

                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head">
                    <tr>
                      <th>{i18n.t("job_title.label")}</th>
                      <th>{i18n.t("sender_id.label")}</th>
                      {reactLocalStorage.get("role") === "ROLE_ADMIN" &&(
                      <th>{i18n.t("username.label")}</th>)}
                      <th>{i18n.t("numberofmsgs.label")}</th>
                      <th>{i18n.t("total_recipients.label")} </th>
                      <th>{i18n.t("total_delievered.label")}</th>
                      <th>{i18n.t("total_failed.label")}</th>
                      <th>{i18n.t("Status.label")}</th>
                      <th>{i18n.t("Schedule_date.label")}</th>
                      <th>{i18n.t("view_details.label")}</th>
                    </tr>
                  </thead>
                  <tbody response>
                    {this.state.data.map((person) => (
                      <tr>
                        <td>{person.title} </td>
                        <td>{person.sender_id}</td>
                        {reactLocalStorage.get("role") === "ROLE_ADMIN" &&(<td>{person.userName}</td>)}
                        <td>{commaNumber(person.total_messages)} </td>
                        <td>{commaNumber(person.total_recipients)}</td>
                        <td>{commaNumber(person.total_delievered)}</td>
                        <td>{commaNumber(person.total_rejected)}</td>
                        <td> {person.status}</td>
                        <td>
                          {person.schedule_date
                            ? this.test(person.schedule_date)
                            : ""}
                        </td>
                        <td>
                          {" "}
                          {person.status === "completed" ? (
                            <Button
                              floated="right"
                              icon
                              labelPosition="left"
                              basic
                              color="black"
                              size="mini"
                              id={person.id}
                              onClick={this.viewdata}
                              style={{ width: "120px" }}
                            >
                              <Icon name="eye" className="eye" id={person.id} />
                              {this.state.isArabic ? "عرض" : "View"}
                            </Button>
                          ) : (
                            ""
                          )}
                          {person.status === "stopped" ? (
                            <Button
                              floated="right"
                              icon
                              labelPosition="left"
                              basic
                              color="black"
                              size="mini"
                              id={person.id}
                              onClick={this.viewdata}
                              style={{ width: "120px" }}
                            >
                              <Icon name="eye" className="eye" id={person.id} />
                              {this.state.isArabic ? "عرض" : "View"}
                            </Button>
                          ) : (
                            ""
                          )}
                          {person.status === "cancelled" ? (
                            <Button
                              floated="right"
                              disabled
                              icon
                              labelPosition="left"
                              basic
                              color="black"
                              size="mini"
                              id={person.id}
                              onClick={this.viewdata}
                              style={{ width: "120px" }}
                            >
                              <Icon name="eye" className="eye" id={person.id} />
                              {this.state.isArabic ? "عرض" : "View"}
                            </Button>
                          ) : (
                            ""
                          )}
                          {person.status == "scheduled" ? (
                            <div>
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={this.stopJob}
                                style={{ width: "120px" }}
                              >
                                <Icon
                                  name="times circle outline"
                                  id={person.id}
                                />
                                {this.state.isArabic ? "إلغاء" : "Cancel"}
                              </Button>
                              <br />
                              <br />
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                color="black"
                                size="mini"
                                disabled={
                                  person.recipient_numbers_type ===
                                  "dynamic_file"
                                    ? true
                                    : false
                                }
                                id={person.id}
                                onClick={(event) => {
                                  this.openEdit(event);
                                }}
                                style={{ width: "120px" }}
                              >
                                <Icon
                                  name="edit circle outline"
                                  id={person.id}
                                />
                                {this.state.isArabic ? "تعديل" : "Edit"}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          {person.status === "running" ? (
                            <div>
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                color="teal"
                                size="mini"
                                id={person.id}
                                onClick={this.viewdata}
                                style={{ width: "120px" }}
                              >
                                <Icon
                                  name="eye"
                                  className="eye"
                                  id={person.id}
                                />
                                {this.state.isArabic ? "عرض" : "View"}
                              </Button>

                              <br />
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={this.stopJob}
                                style={{ width: "120px" }}
                              >
                                <Icon
                                  name="times circle outline "
                                  id={person.id}
                                />
                                {this.state.isArabic ? "إلغاء" : "cancel"}
                              </Button>
                              <br />
                              <br />
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={this.pauseJob}
                                style={{ width: "120px" }}
                              >
                                <Icon name="pause" id={person.id} />
                                {this.state.isArabic ? "إلغاء" : "pause"}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          {person.status === "sent" ? (
                            <Button
                              floated="right"
                              icon
                              labelPosition="left"
                              basic
                              color="black"
                              size="mini"
                              id={person.id}
                              onClick={this.viewdata}
                              style={{ width: "120px" }}
                            >
                              <Icon name="eye" className="eye" id={person.id} />
                              {this.state.isArabic ? "عرض" : "View"}
                            </Button>
                          ) : (
                            ""
                          )}
                          {person.status === "paused" ? (
                            <div>
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={this.resumeJob}
                                style={{ width: "120px" }}
                              >
                                <Icon
                                  name="caret square right"
                                  id={person.id}
                                />
                                {this.state.isArabic ? "إعادة تشغيل" : "resume"}
                              </Button>
                              <br />
                              <br />
                            </div>
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <br />

                <br />
                <br />
                <div className="bulkpagination">
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChange}
                        totalPages={this.state.bulktotalpage}
                        className="page"
                        floated={this.state.isArabic ? "left" : "right"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>

                <div
                  className="searchbulkpagination"
                  style={{ display: "none" }}
                >
                  <Segment basic />

                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChangeSearchBasic}
                        totalPages={this.state.searchbulktotalpage}
                        className="page"
                        floated={this.state.isArabic ? "left" : "right"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>

                <div className="filterpagination" style={{ display: "none" }}>
                  <Segment basic />

                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationFilterChange}
                        totalPages={this.state.filterTotalpage}
                        className="page"
                        floated={this.state.isArabic ? "left" : "right"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>
              </Segment>
            </div>
          </div>
          <Modal
            open={this.state.modalOpenBulkSMSStepOne}
            style={this.state.isArabic ? StepOneModala : StepOneModal}
            size="small"
            className="add"
          >
            <Header icon="pencil alternate" content=" Add Bulk SMS" />
            <Modal.Content scrolling>
              <Modal.Description>
                <Header>
                  <Step.Group widths={3} ordered>
                    <Step active>
                      <Step.Content>
                        <Step.Title>
                          {this.state.isArabic
                            ? "معلومات الرسائل"
                            : "SMS Information"}{" "}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "إدارة الرسائل"
                            : "SMS Managment"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "تأكيد العملية"
                            : "Process Confirmtion"}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  </Step.Group>
                  <br />
                </Header>
                <Form>
                  <label
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                    style={{
                      float:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  >
                    {i18n.t("Title.label")}
                  </label>
                  <input
                    required="required"
                    type="text"
                    id="defaultFormCardNameEx"
                    className="form-control title_data"
                    value={this.state.title}
                    name="name"
                    onChange={this.handleChangeTitle}
                  />
                  <br />
                  <p
                    className="h6 black_color"
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  >
                    {i18n.t("Sender_ID.label")}
                  </p>

                  <Select
                    placeholder={i18n.t("select.label")}
                    search
                    selection
                    options={this.state.countryOptions}
                    onChange={this.onChangesenderid.bind(this)}
                    style={{ width: "100%" }}
                  />
                  <br />
                  <p
                    className="h6 black_color"
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  >
                    {i18n.t("Recipient_numbers_type.label")}
                  </p>

                  <Select
                    fluid
                    search
                    selection
                    value={this.state.typeofMSg}
                    className="select_data"
                    placeholder={this.state.nameoftype}
                    options={this.state.products}
                    onChange={this.onChange.bind(this)}
                    id="dropselect"
                  />

                  <br />
                  <div className="mobile_div" style={{ display: "none" }}>
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("Mobile_Number.label")}
                    </p>

                    <PhoneInput
                      required
                      country={"jo"}
                      value={this.state.mobile}
                      onChange={this.handleChangeMobile}
                      defaultCountry={"jo"}
                      onlyCountries={["jo"]}
                      excludeCountries={["il"]}
                      inputStyle={{
                        paddingLeft: "50px",
                      }}
                      className="phone"
                    />
                  </div>

                  <div className="upload_div" style={{ display: "none" }}>
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("Upload_file.label")}
                    </p>
                    <input
                      type="file"
                      id="defaultFormCardNameEx"
                      // className="form-control input_file"
                      name="mobile"
                      required="required"
                      onChange={this.handleChangeupload}
                      key={this.state.inputKey}
                    />
                  </div>

                  <div className="group_div" style={{ display: "none" }}>
                    <p
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("Groups.label")}
                    </p>
                    <Select
                      placeholder={i18n.t("select.label")}
                      fluid
                      isMulti
                      search
                      selection
                      options={groupOptions}
                      onChange={this.onChangegroup.bind(this)}
                      className="group_input"
                      key={this.state.inputKey}
                    />
                    <br />

                    <p
                      style={{
                        width: "100%",
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("add_numbers.label")}
                      <ul style={styles.container}>
                        {this.state.items.map((item, i) => (
                          <li
                            key={i}
                            style={styles.items}
                            onClick={this.handleRemoveItem(i)}
                          >
                            {item}
                            <span>(x)</span>
                          </li>
                        ))}
                        <input
                          style={styles.input}
                          value={this.state.input}
                          onChange={this.handleInputChange}
                          onKeyUp={this.handleInputKeyDown}
                          className="add_number"
                        />
                      </ul>
                    </p>
                    <br />

                    <p
                      style={{
                        width: "100%",
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("remove_numbers.label")}
                      <ul style={styles.container}>
                        {this.state.items2.map((item, i) => (
                          <li
                            key={i}
                            style={styles.items2}
                            onClick={this.handleRemoveItem2(i)}
                          >
                            {item}
                            <span>(x)</span>
                          </li>
                        ))}
                        <input
                          style={styles.input2}
                          value={this.state.input2}
                          onChange={this.handleInputChange2}
                          onKeyUp={this.handleInputKeyDown2}
                          className="add_number"
                        />
                      </ul>
                    </p>
                  </div>
                  <div className="category_div" style={{ display: "none" }}>
                    <Select
                      placeholder={i18n.t("select.label")}
                      fluid
                      isMulti
                      search
                      selection
                      options={categoryOptions}
                      onChange={this.onChangecategory.bind(this)}
                      className="category_input"
                      key={this.state.inputKey}
                    />
                    <br />

                    <div className="append_data">
                      <Select
                        placeholder={i18n.t("Select_group.label")}
                        fluid
                        isMulti
                        search
                        selection
                        options={
                          categoryGroupOptions
                            ? this.viewcategoryGroupOptions()
                            : ""
                        }
                        onChange={this.onChangecategoryGroup.bind(this)}
                        className="categoryGroup"
                        style={{ display: "none" }}
                      />
                      <br />
                      <br />
                    </div>
                  </div>
                  <br />
                </Form>
                <br /> <br />
              </Modal.Description>
            </Modal.Content>

            <Modal.Actions>
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseBulkSMSStepOne}
              />
              <Button
                basic
                color="teal"
                onClick={() => {
                  this.openstep2();
                }}
              >
                {i18n.t("Next.label")} <Icon name="right chevron" />
              </Button>
            </Modal.Actions>
          </Modal>
          <Modal
            open={this.state.modalOpenBulkSMSStepTow}
            style={this.state.isArabic ? StepOneModala : StepOneModal}
            className="add"
            size="small"
          >
            <Header icon="pencil alternate" content=" Add Bulk SMS" />

            <Modal.Content scrolling>
              <Modal.Description>
                <Header>
                  <Step.Group widths={3} ordered>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {this.state.isArabic
                            ? "معلومات الرسائل"
                            : "SMS Information"}{" "}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                    <Step active>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "إدارة الرسائل"
                            : "SMS Managment"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "تأكيد العملية"
                            : "Process Confirmtion"}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  </Step.Group>
                  <br />
                </Header>
                <Form>
                  <p
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  >
                    {i18n.t("Select_Time.label")}
                  </p>
                  <Select
                    options={this.state.time}
                    onChange={this.onChangetime.bind(this)}
                    defaultValue={this.state.timeselect}
                    placeholder={this.state.timeselect}
                  />
                  <br />
                  <span
                    className="templates-class"
                    style={{
                      display:
                        this.state.typeofMSg === "dynamic_file"
                          ? "none "
                          : "block",
                    }}
                  >
                    <p
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("Template.label")}
                    </p>

                    <Select
                      placeholder={i18n.t("select.label")}
                      fluid
                      search
                      selection
                      options={template}
                      onChange={this.onChangetemplate.bind(this)}
                    />
                  </span>
                  <br />
                  <div className="time_div" style={{ display: "none" }}>
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light"
                      style={{
                        width: "100%",
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("Time.label")}
                    </p>
                    <DateTime
                      onChange={this.onChangedatetime}
                      value={this.state.date}
                      className="test"
                      closeOnSelect={true}
                      closeOnTab={true}
                      locale={i18n.language}
                      isValidDate={valid}
                    />

                    {/* <DateTimePicker
                    onChange={this.onChangedatetime}
                    value={this.state.date}
                    firstDayOfWeek={1}
                  /> */}
                    <br />
                    <br />
                  </div>

                  <span
                    style={{
                      display:
                        this.state.typeofMSg === "dynamic_file"
                          ? "none "
                          : "block",
                    }}
                  >
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light content_label templates-class"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                      }}
                    >
                      {i18n.t("Content.label")}
                    </p>
                    <Button
                      className="add_variable_btn"
                      style={{ display: "none" }}
                      onClick={this.addVariables}
                    >
                      {i18n.t("Add_variables.label")}
                    </Button>
                    <textarea
                      className="form-control templates-class textarea_content"
                      id="contentArea"
                      name="mobile"
                      required="required"
                      onChange={this.handleChangeContent}
                      value={this.state.content}
                    />

                    <span
                      class="textarea__countar"
                      style={{ float: "right", display: "none" }}
                    >
                      {this.state.content.length}/
                      {/* {Math.ceil(this.state.content.length / 70)} */}
                      {this.state.numberOfMessages}
                      {/*  ////////////// number of arabic messages /////////////// */}
                    </span>
                    <span
                      class="textarea__countar_varaibles"
                      style={{ float: "right", display: "none" }}
                    >
                      {i18n.t("count_variable.label")} :{count}
                    </span>

                    <span class="textarea__counten" style={{ float: "right" }}>
                      {this.state.content.length}/{this.state.numberOfMessages}
                    </span>

                    <span
                      class="textarea__counten_varaibles"
                      style={{ float: "left", display: "none" }}
                    >
                      {i18n.t("count_variable.label")} :{count}
                    </span>
                  </span>
                  {/* <br />
                  <Button
                    floated="left"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.showMobigram}
                  >
                    <span
                      style={{ fontWeight: "bold", color: "black" }}
                      id="demo"
                    >
                      {" "}
                      Mobigram
                    </span>
                    <Icon color="black" name="text height" color="black" />
                  </Button> 

                  <br />
                  <br />
                  <div
                    style={{ border: "1px solid gainsboro", display: "none" }}
                    className="mobigram"
                  >
                    <EditorConvertToHTML
                      parentCallback={this.handleSubmitEditor}
                      loading={this.state.loading}
                    />
                  </div>*/}

                  <br />
                  <br />
                  <Button
                    floated="left"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.showRecurring}
                  >
                    <span
                      style={{ fontWeight: "bold", color: "black" }}
                      id="demo"
                    >
                      {" "}
                      Recurring SMS
                    </span>
                    <Icon color="black" name="redo alternate" />
                  </Button>

                  <br />
                  <br />

                  <div className="recurring" style={{ display: "none" }}>
                    <br />

                    <table>
                      <tr>
                        <td style={{ width: "90%" }}>
                          <DateTime
                            onChange={this.onChangedatetimerecurring}
                            value={this.state.recurring}
                            className="test"
                            //closeOnSelect={true}
                            closeOnTab={true}
                            locale={i18n.language}
                            id="candidate"
                          />
                        </td>
                        <td>
                          <Button
                            floated="left"
                            icon
                            labelPosition="left"
                            basic
                            size="small"
                            onClick={() => {
                              this.handleDayClick();
                            }}
                          >
                            <Icon name="plus" />
                            Add
                          </Button>
                        </td>
                      </tr>
                    </table>

                    <br />

                    <br />
                    <div className="viewTable" style={{ display: "none" }}>
                      {this.state.view.map((date, index) => (
                        <Segment basic color="teal" padded>
                          {date}
                          <Button
                            basic
                            content="Delete Date"
                            icon="delete calendar"
                            labelPosition="right"
                            floated="right"
                            id={index}
                            onClick={() => {
                              this.removeItem(index);
                            }}
                          />

                          <br />

                          <br />
                        </Segment>
                      ))}

                      <br />
                      <br />
                    </div>
                  </div>

                  <br />
                  <br />
                  <br />
                  <br />
                </Form>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="black"
                onClick={() => {
                  this.goBack();
                }}
              >
                {" "}
                <Icon name="left chevron" /> {i18n.t("Back.label")}
              </Button>
              <Button
                basic
                color="teal"
                onClick={this.state.disabledButton == true ? null : this.submit}
              >
                {i18n.t("Next.label")} <Icon name="right chevron" />
              </Button>
            </Modal.Actions>
          </Modal>
          <Modal
            open={this.state.modalOpenConfirm}
            size="small"
            style={this.state.isArabic ? StepOneModala : StepOneModal}
            className="add"
          >
            <Header icon="pencil alternate" content="Add Bulk SMS" />
            <Modal.Content>
              <Modal.Description>
                <Header>
                  <Step.Group widths={3} ordered>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {this.state.isArabic
                            ? "معلومات الرسائل"
                            : "SMS Information"}{" "}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "إدارة الرسائل"
                            : "SMS Managment"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step active>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "تأكيد العملية"
                            : "Process Confirmtion"}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  </Step.Group>
                  <br />
                </Header>
                <Form
                  style={{
                    textAlign:
                      reactLocalStorage.get("lang") === "ar" ? "right" : "left",
                  }}
                >
                  <Form.Input
                    label={i18n.t("totalmsg.label")}
                    value={commaNumber(this.state.totalmsg)}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  />

                  <Form.Input
                    label={i18n.t("totalValid_Number.label")}
                    value={commaNumber(this.state.resultall)}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  />

                  <Form.Input
                    label={i18n.t("totalinValid_Number.label")}
                    value={commaNumber(this.state.resultallinvalid)}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  />
                  <Form.Input
                    label={i18n.t("totalDuplicate_Number.label")}
                    value={commaNumber(this.state.totalduplicate || 0)}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  />

                  {/* <Form.Input
                    label={i18n.t("balance_reserved.label")}
                    value={this.state.balance_reserved}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  /> */}

                  <div
                    style={{
                      display: this.state.confirm_id === "" ? "block" : "none",
                    }}
                  >
                    <Segment basic style={{ paddingTop: "6px" }}>
                      <Header as="h3" color="grey">
                        <Icon name="warning sign" loading />

                        <Header.Content>
                          Please wait your admin to approve your request, You
                          can leave the page now..
                        </Header.Content>
                      </Header>
                    </Segment>
                  </div>
                </Form>
              </Modal.Description>
            </Modal.Content>

            <Modal.Actions>
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseConfirm}
              />
              <Button
                basic
                color="teal"
                content={i18n.t("Confirm.label")}
                onClick={this.confirm_msg}
                id="confirm_sms"
                disabled={this.state.confirm_id === "" ? true : false}
              />
              <Button
                basic
                color="teal"
                content={i18n.t("Close.label")}
                onClick={() => {
                  this.Close();
                }}
                disabled={this.state.confirm_id === "" ? false : true}
              />
            </Modal.Actions>
          </Modal>
          <Modal
            size="big"
            open={this.state.modalOpenSellectContact}
            style={this.state.isArabic ? StepOneModala : StepOneModal}
            className="add"
          >
            <Header
              icon="checkmark box"
              content={
                this.state.isArabic ? "اختر جهة الاتصال" : "Sellect Contact"
              }
            />
            <Header textAlign="right">
              <Input
                size="small"
                icon="search"
                floated="right"
                onChange={this.searchchangeAdd.bind(this)}
                placeholder={
                  this.state.isArabic
                    ? "البحث عن رقم الهاتف"
                    : "Seach By Phone Number "
                }
              />
            </Header>
            <br />
            <br />
            <Modal.Content>
              <Form>
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head">
                    <tr>
                      <td> {i18n.t("Full_Name.label")}</td>
                      <td>{i18n.t("Mobile_Number.label")}</td>
                      <td>{i18n.t("company.label")}</td>
                      <td>{this.state.isArabic ? "اختر" : "Select"}</td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.persons.map((person) => (
                      <tr>
                        <td>
                          {person.first_name} {person.second_name}{" "}
                          {person.family_name}
                        </td>
                        <td>{person.mobile_number} </td>
                        <td>{person.company}</td>

                        <td>
                          <Checkbox
                            label=""
                            style={{ width: "20%" }}
                            onClick={this.addNumber}
                            id={person.mobile_number}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>

                  <tfoot>
                    <div className="contactPagination">
                      {" "}
                      <Segment basic />
                      <Divider horizontal>
                        <Header
                          as="h5"
                          floated={this.state.isArabic ? "left" : "right"}
                        >
                          <Pagination
                            defaultActivePage={1}
                            onPageChange={this.handlePaginationChangeContact}
                            totalPages={this.state.contacttotalpage}
                            className="page"
                          />
                        </Header>
                      </Divider>
                    </div>

                    <div
                      className="searchcontactPagination"
                      style={{ display: "none" }}
                    >
                      <Segment basic />
                      <Divider horizontal>
                        <Header
                          as="h5"
                          floated={this.state.isArabic ? "left" : "right"}
                        >
                          <Pagination
                            defaultActivePage={1}
                            onPageChange={this.handlePaginationChange}
                            totalPages={this.state.searchcontacttotalpage}
                            className="page"
                          />
                        </Header>
                      </Divider>
                    </div>
                  </tfoot>
                </Table>
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Submit.label")}
                onClick={this.handleCloseSellectContact}
              />
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseSellectContact}
              />
            </Modal.Actions>
          </Modal>
          <Modal
            size="tiny"
            open={this.state.modalOpenStopJop}
            style={this.state.isArabic ? modStopa : modStop}
            className="filter"
          >
            <Header icon="warning circle" content={i18n.t("cancel.label")} />
            <Modal.Content>
              <Header as="h3" textAlign="center">
                {" "}
                {i18n.t("Are_you_sure_about_stopping_the_job.label")}
              </Header>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Yes.label")}
                onClick={this.confirmStop}
              />
              <Button
                basic
                color="black"
                content={i18n.t("No.label")}
                onClick={this.handleCloseStopJop}
              />
            </Modal.Actions>
          </Modal>
          <Modal
            size="large"
            open={this.state.modalOpenViewDetails}
            className="filter"
            style={this.state.isArabic ? modDetailsa : modDetails}
          >
            <Header
              icon="clipboard outline"
              content={i18n.t("Details.label")}
            />

            <Modal.Content scrolling>
              <div className="buttonsHeader">
                <Input
                  size="small"
                  icon="search"
                  placeholder={i18n.t("search.label")}
                  style={{ float: "right" }}
                  onChange={this.searchchange.bind(this)}
                />

                <Button
                  floated="right"
                  icon
                  labelPosition="left"
                  basic
                  size="small"
                  onClick={this.export_details.bind(this, this.state.idRecord)}
                >
                  {i18n.t("export_details.label")}
                  <Icon name="file excel" color="black" />
                </Button>
                <br />
              </div>

              {this.state.ViewBoxDetails && (
                <div className="viewDetails">
                  <Message icon className="download_details_box">
                    <Icon name="circle notched" loading />
                    <Message.Content>
                      <Message.Header>Wait for downloading</Message.Header>
                      {this.state.viewData}
                    </Message.Content>
                  </Message>
                </div>
              )}
              <br />
              <br />

              <Table
                hover
                responsive
                border="0"
                style={{ textAlign: this.state.isArabic ? "right" : "left" }}
              >
                <thead className="head">
                  <tr>
                    <th colSpan="7" style={{ maxWidth: "35px" }}>
                      {i18n.t("Message.label")}
                    </th>
                    <th colSpan="2">{i18n.t("Mobile_Number.label")}</th>

                    <th>{i18n.t("Status.label")}</th>
                    <th>{i18n.t("Schedule_date.label")}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.Details.map((person) => (
                    <tr>
                      <td colSpan="7" style={{ maxWidth: "25px" }}>
                        {person.message_Content}
                      </td>
                      <td colSpan="2">{person.reciepint_number}</td>

                      <td>{person.delivery_status}</td>
                      <td>{person.send_time}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <br />
                  <div
                    className="detailspagination"
                    style={{ textAlign: "center" }}
                  >
                    {" "}
                    <Header as="h5" floated="right">
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={
                          this.handlePaginationChangeactivePage_modal
                        }
                        totalPages={this.state.detailstotalpage}
                        style={{ float: this.state.isArabic ? "left" : "" }}
                      />
                    </Header>
                  </div>

                  <div
                    className="searchdetailspagination"
                    style={{ display: "none" }}
                  >
                    {" "}
                    <Header as="h5" floated="right">
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.searchchangepage}
                        totalPages={this.state.searchdetailstotalpage}
                        style={{ float: this.state.isArabic ? "left" : "" }}
                      />
                    </Header>
                  </div>
                </tfoot>
              </Table>
            </Modal.Content>

            <Modal.Actions>
              <Button
                color="black"
                content={i18n.t("Close.label")}
                onClick={this.handleCloseViewDetails}
              />
            </Modal.Actions>
          </Modal>
          {/* ////////////////////////////////// filter////////////////////////////////
           */}{" "}
          <Modal
            open={this.state.modalOpenFilterDetails}
            className="filter"
            style={this.state.isArabic ? filtera : filter}
          >
            <Header content="Filter" icon="sort amount up" />
            <Modal.Content scrolling>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                {i18n.t("start_date.label")}
              </label>

              <br />
              <input
                type="date"
                onChange={this.onChangeFromDate}
                className="dateinput"
              />

              <br />

              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                <br />
                {i18n.t("end_date.label")}
              </label>
              {/*// type="datetime-local" */}
              <input
                type="date"
                onChange={this.onChangeToDate}
                className="dateinput"
              />

              <br />
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Submit.label")}
                onClick={() => {
                  this.filterData();
                }}
              />
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseFilterDetails}
              />
            </Modal.Actions>
          </Modal>
          <Modal
            open={this.state.modalOpenBulkEdit}
            style={this.state.isArabic ? StepOneModala : StepOneModal}
            className="add"
            size="small"
          >
            <Header icon="edit outline" content="Edit Bulk SMS" />

            <Modal.Content scrolling>
              <Modal.Description>
                <Form>
                  <p
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                      fontSize: "16px",
                    }}
                  >
                    {i18n.t("Select_Time.label")}
                  </p>
                  <Select
                    options={this.state.time}
                    onChange={this.onChangetime.bind(this)}
                    defaultValue={this.state.timeselect}
                    placeholder={this.state.timeselect}
                  />
                  <br />
                  <span
                    className="templates-class"
                    style={{
                      display:
                        this.state.typeofMSg === "dynamic_file"
                          ? "none "
                          : "block",
                    }}
                  >
                    <p
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Template.label")}
                    </p>

                    <Select
                      placeholder={i18n.t("select.label")}
                      fluid
                      search
                      selection
                      options={template}
                      onChange={this.onChangetemplate.bind(this)}
                    />
                  </span>
                  <br />
                  <div className="time_div" style={{ display: "none" }}>
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light"
                      style={{
                        width: "100%",
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Time.label")}
                    </p>
                    <DateTime
                      onChange={this.onChangedatetime}
                      value={this.state.date}
                      className="test"
                      closeOnSelect={true}
                      closeOnTab={true}
                      locale={i18n.language}
                      isValidDate={valid}
                    />

                    <br />
                    <br />
                  </div>

                  <span
                    style={{
                      display:
                        this.state.typeofMSg === "dynamic_file"
                          ? "none "
                          : "block",
                    }}
                  >
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light content_label templates-class"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Content.label")}
                    </p>
                    <Button
                      className="add_variable_btn"
                      style={{ display: "none" }}
                      onClick={this.addVariables}
                    >
                      {i18n.t("Add_variables.label")}
                    </Button>

                    <textarea
                      className="form-control templates-class textarea_content"
                      id="contentArea"
                      name="mobile"
                      required="required"
                      onChange={this.handleChangeContent}
                      value={this.state.content}
                    />

                    <span
                      class="textarea__countar"
                      style={{ float: "right", display: "none" }}
                    >
                      {this.state.content.length}/
                      {/* {Math.ceil(this.state.content.length / 70)} */}
                      {this.state.numberOfMessagesContent}
                      {/*  ////////////// number of arabic messages /////////////// */}
                    </span>
                    <span
                      class="textarea__countar_varaibles"
                      style={{ float: "right", display: "none" }}
                    >
                      {i18n.t("count_variable.label")} :{count}
                    </span>

                    <span class="textarea__counten" style={{ float: "right" }}>
                      {this.state.content.length}/
                      {this.state.numberOfMessagesContent}
                    </span>

                    <span
                      class="textarea__counten_varaibles"
                      style={{ float: "left", display: "none" }}
                    >
                      {i18n.t("count_variable.label")} :{count}
                    </span>
                  </span>
                  <br />
                  <Button
                    floated="left"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.showMobigram}
                  >
                    <span
                      style={{ fontWeight: "bold", color: "black" }}
                      id="demo"
                    >
                      {" "}
                      Mobigram
                    </span>
                    <Icon color="black" name="text height" />
                  </Button>

                  <br />
                  <br />
                  <div
                    style={{ border: "1px solid gainsboro", display: "none" }}
                    className="mobigram"
                  >
                    <EditorConvertToHTML
                      parentCallback={this.handleSubmitEditor}
                      loading={this.state.loading}
                    />
                  </div>
                </Form>
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button basic color="black" onClick={this.handleCloseBulkEdit}>
                {" "}
                {i18n.t("Cancel.label")}
              </Button>
              <Button
                basic
                color="teal"
                onClick={() => {
                  this.submitEdit();
                }}
              >
                {i18n.t("Submit.label")}
              </Button>
            </Modal.Actions>
          </Modal>
          <br />
          <br />
          <SemanticToastContainer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(ReportBulk);
